unit Factor;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Imaging.pngimage, WEBLib.ExtCtrls,
  WEBLib.StdCtrls, Math, WEBLib.Imaging.jpeg,
  WEBLib.Buttons, uSubForm1, Unit2, Unit3, Unit4, WEBLib.ComCtrls, Variants, StrUtils;


type
  TForm1 = class(TForm)
    WebLabel1: TLabel;
    WebPageControl1: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WebPageControl1Sheet2: TTabSheet;
    WebPageControl1Sheet3: TTabSheet;
    WebGroupBox3: TGroupBox;
    WebLabel45: TLabel;
    WebLabel47: TLabel;
    WebLabel48: TLabel;
    WebLabel50: TLabel;
    WebLabel51: TLabel;
    WebLabel52: TLabel;
    WebLabel53: TLabel;
    WebLabel54: TLabel;
    WebLabel55: TLabel;
    WebLabel56: TLabel;
    WebLabel57: TLabel;
    WebLabel58: TLabel;
    WebLabel59: TLabel;
    WebLabel60: TLabel;
    WebLabel61: TLabel;
    WebLabel64: TLabel;
    WebLabel65: TLabel;
    WebLabel46: TLabel;
    WebLabel72: TLabel;
    WebLabel73: TLabel;
    WebLabel81: TLabel;
    WebLabel82: TLabel;
    WebLabel83: TLabel;
    WebEdit10: TEdit;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebEdit18: TEdit;
    WebEdit31: TEdit;
    WebEdit32: TEdit;
    WebEdit34: TEdit;
    WebEdit6: TEdit;
    WebComboBox7: TComboBox;
    WebEdit1: TEdit;
    WebEdit33: TEdit;
    WebEdit35: TEdit;
    WebGroupBox4: TGroupBox;
    WebLabel66: TLabel;
    WebLabel68: TLabel;
    WebLabel71: TLabel;
    WebLabel75: TLabel;
    WebLabel77: TLabel;
    WebLabel79: TLabel;
    WebLabel80: TLabel;
    WebLabel85: TLabel;
    WebLabel87: TLabel;
    WebLabel89: TLabel;
    WebLabel91: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebEdit36: TEdit;
    WebEdit37: TEdit;
    WebEdit38: TEdit;
    WebEdit39: TEdit;
    WebEdit40: TEdit;
    WebEdit41: TEdit;
    WebEdit42: TEdit;
    WebEdit43: TEdit;
    WebEdit44: TEdit;
    WebEdit45: TEdit;
    WebEdit46: TEdit;
    WebEdit2: TEdit;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    WebEdit5: TEdit;
    WebGroupBox1: TGroupBox;
    WebLabel7: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebLabel30: TLabel;
    WebLabel31: TLabel;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebEdit11: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebEdit15: TEdit;
    WebEdit19: TEdit;
    WebEdit20: TEdit;
    WebEdit21: TEdit;
    WebEdit22: TEdit;
    WebEdit23: TEdit;
    WebEdit24: TEdit;
    WebEdit25: TEdit;
    WebEdit26: TEdit;
    WebEdit27: TEdit;
    WebEdit28: TEdit;
    WebEdit29: TEdit;
    WebEdit30: TEdit;
    WebEdit47: TEdit;
    WebEdit48: TEdit;
    WebEdit49: TEdit;
    WebEdit50: TEdit;
    WebEdit51: TEdit;
    WebEdit52: TEdit;
    WebEdit53: TEdit;
    WebEdit54: TEdit;
    WebEdit55: TEdit;
    WebEdit56: TEdit;
    WebEdit57: TEdit;
    WebEdit58: TEdit;
    WebEdit59: TEdit;
    WebEdit60: TEdit;
    WebEdit61: TEdit;
    WebEdit62: TEdit;
    WebEdit63: TEdit;
    WebEdit64: TEdit;
    WebEdit65: TEdit;
    WebEdit66: TEdit;
    WebEdit67: TEdit;
    WebEdit68: TEdit;
    WebEdit69: TEdit;
    WebEdit70: TEdit;
    WebEdit71: TEdit;
    WebEdit72: TEdit;
    WebEdit73: TEdit;
    WebEdit74: TEdit;
    WebEdit75: TEdit;
    WebEdit76: TEdit;
    WebEdit77: TEdit;
    WebEdit78: TEdit;
    WebEdit79: TEdit;
    WebEdit80: TEdit;
    WebEdit81: TEdit;
    WebPageControl1Sheet4: TTabSheet;
    WebGroupBox2: TGroupBox;
    WebLabel32: TLabel;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    WebLabel35: TLabel;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    WebLabel38: TLabel;
    WebLabel39: TLabel;
    WebLabel40: TLabel;
    WebLabel41: TLabel;
    WebLabel42: TLabel;
    WebLabel43: TLabel;
    WebLabel44: TLabel;
    WebLabel49: TLabel;
    WebLabel62: TLabel;
    WebLabel63: TLabel;
    WebLabel67: TLabel;
    WebLabel69: TLabel;
    WebLabel70: TLabel;
    WebLabel74: TLabel;
    WebLabel76: TLabel;
    WebLabel78: TLabel;
    WebLabel84: TLabel;
    WebLabel86: TLabel;
    WebEdit82: TEdit;
    WebEdit83: TEdit;
    WebEdit84: TEdit;
    WebEdit85: TEdit;
    WebEdit86: TEdit;
    WebEdit87: TEdit;
    WebEdit88: TEdit;
    WebEdit89: TEdit;
    WebEdit90: TEdit;
    WebEdit91: TEdit;
    WebEdit92: TEdit;
    WebEdit93: TEdit;
    WebEdit94: TEdit;
    WebEdit95: TEdit;
    WebEdit96: TEdit;
    WebEdit97: TEdit;
    WebEdit98: TEdit;
    WebEdit99: TEdit;
    WebEdit100: TEdit;
    WebEdit101: TEdit;
    WebEdit102: TEdit;
    WebEdit103: TEdit;
    WebEdit104: TEdit;
    WebEdit105: TEdit;
    WebEdit106: TEdit;
    WebEdit107: TEdit;
    WebEdit108: TEdit;
    WebEdit109: TEdit;
    WebEdit110: TEdit;
    WebEdit111: TEdit;
    WebEdit112: TEdit;
    WebEdit113: TEdit;
    WebBitBtn1: TBitBtn;
    WebBitBtn2: TBitBtn;
    WebBitBtn3: TBitBtn;
    WebBitBtn4: TBitBtn;
    WebLabel88: TLabel;
    WebLabel90: TLabel;
    WebLabel92: TLabel;
    WebEdit114: TEdit;
    WebLabel93: TLabel;
    WebLabel94: TLabel;
    WebEdit115: TEdit;
    WebLabel95: TLabel;
    WebLabel96: TLabel;
    WebEdit117: TEdit;
    WebEdit118: TEdit;
    WebImageControl1: TImageControl;
    WebImageControl4: TImageControl;
    WebImageControl2: TImageControl;
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebComboBox2Change(Sender: TObject);
    procedure WebComboBox3Change(Sender: TObject);
    procedure WebEdit6Change(Sender: TObject);
    procedure WebEdit7Change(Sender: TObject);
    procedure WebEdit2Change(Sender: TObject);
    procedure WebEdit15Change(Sender: TObject);
    procedure WebEdit12Change(Sender: TObject);
    procedure WebEdit3Change(Sender: TObject);
    procedure WebEdit10Change(Sender: TObject);
    procedure WebEdit13Change(Sender: TObject);
    procedure WebEdit9Change(Sender: TObject);
    procedure WebEdit5KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit9KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit7KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit15KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit2KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit3KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit12KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit13KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit1Change(Sender: TObject);
    procedure WebEdit5Change(Sender: TObject);
    procedure WebEdit4Change(Sender: TObject);
    procedure WebEdit8Change(Sender: TObject);
    procedure WebEdit11Change(Sender: TObject);
    procedure WebEdit14Change(Sender: TObject);
    procedure WebEdit17Change(Sender: TObject);
    procedure WebEdit18Change(Sender: TObject);
    procedure WebEdit19Change(Sender: TObject);
    procedure WebComboBox4Change(Sender: TObject);
    procedure WebComboBox5Change(Sender: TObject);
    procedure WebEdit14KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit11KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit8KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit20KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit19KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit21KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit23KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit22KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit25KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit27KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit29KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit28KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit30KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebComboBox6Change(Sender: TObject);
    procedure WebBitBtn1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebBitBtn2Click(Sender: TObject);
    procedure WebBitBtn3Click(Sender: TObject);
    procedure WebBitBtn4Click(Sender: TObject);
  private
    frm: TForm;
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form1     : TForm1;
  Wysokosc  : array[0..23] of Real;
  Dc, SN    : Integer;
  Cj        : Real;

implementation


var nett: Double;         // Brutto-, Nettobetrag
    code: Integer;               // Hilfsvariablen

procedure Sprawdz;
begin
      Form1.WebEdit1.Text:=AnsiReplaceText(Form1.WebEdit1.Text,'.',',');
      Form1.WebEdit3.Text:=AnsiReplaceText(Form1.WebEdit3.Text,'.',',');
      Form1.WebEdit4.Text:=AnsiReplaceText(Form1.WebEdit4.Text,'.',',');
      Form1.WebEdit5.Text:=AnsiReplaceText(Form1.WebEdit5.Text,'.',',');
      Form1.WebEdit6.Text:=AnsiReplaceText(Form1.WebEdit6.Text,'.',',');
      Form1.WebEdit7.Text:=AnsiReplaceText(Form1.WebEdit7.Text,'.',',');
      Form1.WebEdit8.Text:=AnsiReplaceText(Form1.WebEdit8.Text,'.',',');
      Form1.WebEdit9.Text:=AnsiReplaceText(Form1.WebEdit9.Text,'.',',');
      Form1.WebEdit10.Text:=AnsiReplaceText(Form1.WebEdit10.Text,'.',',');
      Form1.WebEdit11.Text:=AnsiReplaceText(Form1.WebEdit11.Text,'.',',');
      Form1.WebEdit12.Text:=AnsiReplaceText(Form1.WebEdit12.Text,'.',',');
      Form1.WebEdit13.Text:=AnsiReplaceText(Form1.WebEdit13.Text,'.',',');
      Form1.WebEdit14.Text:=AnsiReplaceText(Form1.WebEdit14.Text,'.',',');
      Form1.WebEdit16.Text:=AnsiReplaceText(Form1.WebEdit16.Text,'.',',');
      Form1.WebEdit17.Text:=AnsiReplaceText(Form1.WebEdit17.Text,'.',',');
      Form1.WebEdit18.Text:=AnsiReplaceText(Form1.WebEdit18.Text,'.',',');
      Form1.WebEdit19.Text:=AnsiReplaceText(Form1.WebEdit19.Text,'.',',');
      Form1.WebEdit20.Text:=AnsiReplaceText(Form1.WebEdit20.Text,'.',',');
      Form1.WebEdit21.Text:=AnsiReplaceText(Form1.WebEdit21.Text,'.',',');
      Form1.WebEdit23.Text:=AnsiReplaceText(Form1.WebEdit23.Text,'.',',');
      Form1.WebEdit24.Text:=AnsiReplaceText(Form1.WebEdit24.Text,'.',',');
      Form1.WebEdit25.Text:=AnsiReplaceText(Form1.WebEdit25.Text,'.',',');
      Form1.WebEdit26.Text:=AnsiReplaceText(Form1.WebEdit26.Text,'.',',');
      Form1.WebEdit27.Text:=AnsiReplaceText(Form1.WebEdit27.Text,'.',',');
      Form1.WebEdit28.Text:=AnsiReplaceText(Form1.WebEdit28.Text,'.',',');
      Form1.WebEdit29.Text:=AnsiReplaceText(Form1.WebEdit29.Text,'.',',');
      Form1.WebEdit30.Text:=AnsiReplaceText(Form1.WebEdit30.Text,'.',',');
      Form1.WebEdit31.Text:=AnsiReplaceText(Form1.WebEdit31.Text,'.',',');
      Form1.WebEdit32.Text:=AnsiReplaceText(Form1.WebEdit32.Text,'.',',');
      Form1.WebEdit33.Text:=AnsiReplaceText(Form1.WebEdit33.Text,'.',',');
      Form1.WebEdit34.Text:=AnsiReplaceText(Form1.WebEdit34.Text,'.',',');
      Form1.WebEdit36.Text:=AnsiReplaceText(Form1.WebEdit36.Text,'.',',');
      Form1.WebEdit37.Text:=AnsiReplaceText(Form1.WebEdit37.Text,'.',',');
      Form1.WebEdit38.Text:=AnsiReplaceText(Form1.WebEdit38.Text,'.',',');
      Form1.WebEdit39.Text:=AnsiReplaceText(Form1.WebEdit39.Text,'.',',');
      Form1.WebEdit40.Text:=AnsiReplaceText(Form1.WebEdit40.Text,'.',',');
      Form1.WebEdit41.Text:=AnsiReplaceText(Form1.WebEdit41.Text,'.',',');
      Form1.WebEdit43.Text:=AnsiReplaceText(Form1.WebEdit43.Text,'.',',');
      Form1.WebEdit44.Text:=AnsiReplaceText(Form1.WebEdit44.Text,'.',',');
      Form1.WebEdit46.Text:=AnsiReplaceText(Form1.WebEdit46.Text,'.',',');
      Form1.WebEdit45.Text:=AnsiReplaceText(Form1.WebEdit45.Text,'.',',');
      Form1.WebEdit47.Text:=AnsiReplaceText(Form1.WebEdit47.Text,'.',',');
      Form1.WebEdit48.Text:=AnsiReplaceText(Form1.WebEdit48.Text,'.',',');
      Form1.WebEdit50.Text:=AnsiReplaceText(Form1.WebEdit50.Text,'.',',');
      Form1.WebEdit51.Text:=AnsiReplaceText(Form1.WebEdit51.Text,'.',',');
      Form1.WebEdit52.Text:=AnsiReplaceText(Form1.WebEdit52.Text,'.',',');
      Form1.WebEdit53.Text:=AnsiReplaceText(Form1.WebEdit53.Text,'.',',');
      Form1.WebEdit54.Text:=AnsiReplaceText(Form1.WebEdit54.Text,'.',',');
      Form1.WebEdit55.Text:=AnsiReplaceText(Form1.WebEdit55.Text,'.',',');
      Form1.WebEdit56.Text:=AnsiReplaceText(Form1.WebEdit56.Text,'.',',');
      Form1.WebEdit57.Text:=AnsiReplaceText(Form1.WebEdit57.Text,'.',',');
      Form1.WebEdit58.Text:=AnsiReplaceText(Form1.WebEdit58.Text,'.',',');
      Form1.WebEdit59.Text:=AnsiReplaceText(Form1.WebEdit59.Text,'.',',');
      Form1.WebEdit61.Text:=AnsiReplaceText(Form1.WebEdit61.Text,'.',',');
      Form1.WebEdit62.Text:=AnsiReplaceText(Form1.WebEdit62.Text,'.',',');
      Form1.WebEdit63.Text:=AnsiReplaceText(Form1.WebEdit63.Text,'.',',');
      Form1.WebEdit64.Text:=AnsiReplaceText(Form1.WebEdit64.Text,'.',',');
      Form1.WebEdit65.Text:=AnsiReplaceText(Form1.WebEdit65.Text,'.',',');
      Form1.WebEdit66.Text:=AnsiReplaceText(Form1.WebEdit66.Text,'.',',');
      Form1.WebEdit67.Text:=AnsiReplaceText(Form1.WebEdit67.Text,'.',',');
      Form1.WebEdit68.Text:=AnsiReplaceText(Form1.WebEdit68.Text,'.',',');
      Form1.WebEdit69.Text:=AnsiReplaceText(Form1.WebEdit69.Text,'.',',');
      Form1.WebEdit70.Text:=AnsiReplaceText(Form1.WebEdit70.Text,'.',',');
      Form1.WebEdit72.Text:=AnsiReplaceText(Form1.WebEdit72.Text,'.',',');
      Form1.WebEdit73.Text:=AnsiReplaceText(Form1.WebEdit73.Text,'.',',');
      Form1.WebEdit74.Text:=AnsiReplaceText(Form1.WebEdit74.Text,'.',',');
      Form1.WebEdit75.Text:=AnsiReplaceText(Form1.WebEdit75.Text,'.',',');
      Form1.WebEdit76.Text:=AnsiReplaceText(Form1.WebEdit76.Text,'.',',');
      Form1.WebEdit77.Text:=AnsiReplaceText(Form1.WebEdit77.Text,'.',',');
      Form1.WebEdit78.Text:=AnsiReplaceText(Form1.WebEdit78.Text,'.',',');
      Form1.WebEdit79.Text:=AnsiReplaceText(Form1.WebEdit79.Text,'.',',');
      Form1.WebEdit80.Text:=AnsiReplaceText(Form1.WebEdit80.Text,'.',',');
      Form1.WebEdit81.Text:=AnsiReplaceText(Form1.WebEdit81.Text,'.',',');
      Form1.WebEdit82.Text:=AnsiReplaceText(Form1.WebEdit82.Text,'.',',');
      Form1.WebEdit83.Text:=AnsiReplaceText(Form1.WebEdit83.Text,'.',',');
      Form1.WebEdit84.Text:=AnsiReplaceText(Form1.WebEdit84.Text,'.',',');
      Form1.WebEdit87.Text:=AnsiReplaceText(Form1.WebEdit87.Text,'.',',');
      Form1.WebEdit88.Text:=AnsiReplaceText(Form1.WebEdit88.Text,'.',',');
      Form1.WebEdit89.Text:=AnsiReplaceText(Form1.WebEdit89.Text,'.',',');
      Form1.WebEdit91.Text:=AnsiReplaceText(Form1.WebEdit91.Text,'.',',');
      Form1.WebEdit92.Text:=AnsiReplaceText(Form1.WebEdit92.Text,'.',',');
      Form1.WebEdit95.Text:=AnsiReplaceText(Form1.WebEdit95.Text,'.',',');
      Form1.WebEdit96.Text:=AnsiReplaceText(Form1.WebEdit96.Text,'.',',');
      Form1.WebEdit93.Text:=AnsiReplaceText(Form1.WebEdit93.Text,'.',',');
      Form1.WebEdit97.Text:=AnsiReplaceText(Form1.WebEdit97.Text,'.',',');
      Form1.WebEdit98.Text:=AnsiReplaceText(Form1.WebEdit98.Text,'.',',');
      Form1.WebEdit99.Text:=AnsiReplaceText(Form1.WebEdit99.Text,'.',',');
      Form1.WebEdit101.Text:=AnsiReplaceText(Form1.WebEdit101.Text,'.',',');
      Form1.WebEdit102.Text:=AnsiReplaceText(Form1.WebEdit102.Text,'.',',');
      Form1.WebEdit103.Text:=AnsiReplaceText(Form1.WebEdit103.Text,'.',',');
      Form1.WebEdit104.Text:=AnsiReplaceText(Form1.WebEdit104.Text,'.',',');
      Form1.WebEdit105.Text:=AnsiReplaceText(Form1.WebEdit105.Text,'.',',');
      Form1.WebEdit106.Text:=AnsiReplaceText(Form1.WebEdit106.Text,'.',',');
      Form1.WebEdit107.Text:=AnsiReplaceText(Form1.WebEdit107.Text,'.',',');
      Form1.WebEdit108.Text:=AnsiReplaceText(Form1.WebEdit108.Text,'.',',');
      Form1.WebEdit109.Text:=AnsiReplaceText(Form1.WebEdit109.Text,'.',',');
      Form1.WebEdit110.Text:=AnsiReplaceText(Form1.WebEdit110.Text,'.',',');
      Form1.WebEdit111.Text:=AnsiReplaceText(Form1.WebEdit111.Text,'.',',');
      Form1.WebEdit112.Text:=AnsiReplaceText(Form1.WebEdit112.Text,'.',',');
      //   ShowMessage('s2 = '+Form1.WebEdit38.Text);
end;


procedure Przelicz;
 var  s, i1, i2, i3, i4, i5                        : Real;
begin
  i1:=StrtoFloat(Form1.WebEdit6.Text);
  i2:=StrtoFloat(Form1.WebEdit10.Text);
   s:=i1-i2;
  Form1.WebEdit16.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit16.Text);
  i2:=StrtoFloat(Form1.WebEdit17.Text);
   s:=i1-i2;
  Form1.WebEdit18.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit18.Text);
  i2:=StrtoFloat(Form1.WebEdit31.Text);
  i3:=StrtoFloat(Form1.WebEdit32.Text);
  i4:=StrtoFloat(Form1.WebEdit1.Text);
   s:=i1-i2-i3-i4;
  Form1.WebEdit34.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   i1:=StrtoFloat(Form1.WebEdit34.Text);
  i2:=StrtoFloat(Form1.WebEdit33.Text);
   s:=i1-i2;
  Form1.WebEdit35.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  Form1.WebEdit7.Text:= Form1.WebEdit35.Text;
  Form1.WebEdit14.Text:= Form1.WebEdit33.Text;
  Form1.WebEdit15.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text));
  Form1.WebEdit85.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text));
  Form1.WebEdit22.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+1);
  Form1.WebEdit86.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+1);
  Form1.WebEdit49.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+2);
  Form1.WebEdit90.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+2);
  Form1.WebEdit60.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+3);
  Form1.WebEdit94.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+3);
  Form1.WebEdit71.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+4);
  Form1.WebEdit100.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+4);


   i1:=StrtoFloat(Form1.WebEdit7.Text);
  i2:=StrtoFloat(Form1.WebEdit8.Text);
  i3:=StrtoFloat(Form1.WebEdit9.Text);
  i4:=StrtoFloat(Form1.WebEdit11.Text);
  i5:=StrtoFloat(Form1.WebEdit12.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit13.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit23.Text);
  i2:=StrtoFloat(Form1.WebEdit24.Text);
  i3:=StrtoFloat(Form1.WebEdit25.Text);
  i4:=StrtoFloat(Form1.WebEdit26.Text);
  i5:=StrtoFloat(Form1.WebEdit27.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit28.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit50.Text);
  i2:=StrtoFloat(Form1.WebEdit51.Text);
  i3:=StrtoFloat(Form1.WebEdit52.Text);
  i4:=StrtoFloat(Form1.WebEdit53.Text);
  i5:=StrtoFloat(Form1.WebEdit54.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit55.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit61.Text);
  i2:=StrtoFloat(Form1.WebEdit62.Text);
  i3:=StrtoFloat(Form1.WebEdit63.Text);
  i4:=StrtoFloat(Form1.WebEdit64.Text);
  i5:=StrtoFloat(Form1.WebEdit65.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit66.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit72.Text);
  i2:=StrtoFloat(Form1.WebEdit73.Text);
  i3:=StrtoFloat(Form1.WebEdit74.Text);
  i4:=StrtoFloat(Form1.WebEdit75.Text);
  i5:=StrtoFloat(Form1.WebEdit76.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit77.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);

  i1:=StrtoFloat(Form1.WebEdit13.Text);
  i2:=StrtoFloat(Form1.WebEdit14.Text);
  i3:=StrtoFloat(Form1.WebEdit19.Text);
  i4:=StrtoFloat(Form1.WebEdit20.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit21.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit28.Text);
  i2:=StrtoFloat(Form1.WebEdit29.Text);
  i3:=StrtoFloat(Form1.WebEdit30.Text);
  i4:=StrtoFloat(Form1.WebEdit47.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit48.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit55.Text);
  i2:=StrtoFloat(Form1.WebEdit56.Text);
  i3:=StrtoFloat(Form1.WebEdit57.Text);
  i4:=StrtoFloat(Form1.WebEdit58.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit59.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit66.Text);
  i2:=StrtoFloat(Form1.WebEdit67.Text);
  i3:=StrtoFloat(Form1.WebEdit68.Text);
  i4:=StrtoFloat(Form1.WebEdit69.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit70.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit77.Text);
  i2:=StrtoFloat(Form1.WebEdit78.Text);
  i3:=StrtoFloat(Form1.WebEdit79.Text);
  i4:=StrtoFloat(Form1.WebEdit80.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit81.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  Form1.WebEdit102.Text:=  Form1.WebEdit81.Text;
  Form1.WebEdit83.Text:=  Form1.WebEdit21.Text;
  Form1.WebEdit88.Text:=  Form1.WebEdit48.Text;
  Form1.WebEdit92.Text:=  Form1.WebEdit59.Text;
  Form1.WebEdit96.Text:=  Form1.WebEdit70.Text;


   Form1.WebEdit36.Text:=Form1.WebEdit43.Text;

  i1:=StrtoFloat(Form1.WebEdit39.Text);
  i2:=StrtoFloat(Form1.WebEdit40.Text);
   s:=i1-i2;
  Form1.WebEdit41.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  Form1.WebEdit37.Text:=Form1.WebEdit41.Text;
  i1:=StrtoFloat(Form1.WebEdit36.Text);
  i2:=StrtoFloat(Form1.WebEdit37.Text);
   s:=i1+i2;
  Form1.WebEdit38.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit41.Text);
  i2:=StrtoFloat(Form1.WebEdit44.Text);
   s:=i1*i2;
  Form1.WebEdit42.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit45.Text);
  i2:=StrtoFloat(Form1.WebEdit46.Text);
   s:=i1+i2;
  Form1.WebEdit2.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit43.Text);
  i2:=StrtoFloat(Form1.WebEdit45.Text);
   s:=i1*i2/100;
  Form1.WebEdit3.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit38.Text);
  i2:=StrtoFloat(Form1.WebEdit46.Text);
   s:=i1*i2/100;
  Form1.WebEdit4.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit3.Text);
  i2:=StrtoFloat(Form1.WebEdit4.Text);
   s:=i1+i2;
  Form1.WebEdit5.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);


  i1:=(StrtoFloat(Form1.WebEdit5.Text)+100)/100;
  i2:=StrtoFloat(Form1.WebEdit107.Text);
   i4:=i2-1;
   s:=Power(i1,i4);
   s:=1/s;
  Form1.WebEdit82.Text:=FloattoStr(SimpleRoundTo (s * 100000, 0) / 100000);
  i1:=(StrtoFloat(Form1.WebEdit5.Text)+100)/100;
  i2:=StrtoFloat(Form1.WebEdit108.Text);
   i4:=i2-1;
   s:=Power(i1,i4);
   s:=1/s;
  Form1.WebEdit87.Text:=FloattoStr(SimpleRoundTo (s * 100000, 0) / 100000);
  i1:=(StrtoFloat(Form1.WebEdit5.Text)+100)/100;
  i2:=StrtoFloat(Form1.WebEdit109.Text);
   i4:=i2-1;
   s:=Power(i1,i4);
   s:=1/s;
  Form1.WebEdit91.Text:=FloattoStr(SimpleRoundTo (s * 100000, 0) / 100000);
  i1:=(StrtoFloat(Form1.WebEdit5.Text)+100)/100;
  i2:=StrtoFloat(Form1.WebEdit110.Text);
   i4:=i1-1;
   s:=Power(i1,i4);
   s:=1/s;
  Form1.WebEdit95.Text:=FloattoStr(SimpleRoundTo (s * 100000, 0) / 100000);
  i1:=(StrtoFloat(Form1.WebEdit5.Text)+100)/100;
  i2:=StrtoFloat(Form1.WebEdit111.Text);
   i4:=i2-1;
   s:=Power(i1,i4);
   s:=1/s;
  Form1.WebEdit101.Text:=FloattoStr(SimpleRoundTo (s * 100000, 0) / 100000);

   i1:=StrtoFloat(Form1.WebEdit102.Text);
   i2:=StrtoFloat(Form1.WebEdit103.Text);
   s:=i1*i2;
  Form1.WebEdit104.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);

   i1:=StrtoFloat(Form1.WebEdit82.Text);
   i2:=StrtoFloat(Form1.WebEdit83.Text);
   s:=i1*i2;
  Form1.WebEdit84.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);

   i1:=StrtoFloat(Form1.WebEdit87.Text);
   i2:=StrtoFloat(Form1.WebEdit88.Text);
   s:=i1*i2;
  Form1.WebEdit89.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);

   i1:=StrtoFloat(Form1.WebEdit91.Text);
   i2:=StrtoFloat(Form1.WebEdit92.Text);
   s:=i1*i2;
  Form1.WebEdit93.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   i1:=StrtoFloat(Form1.WebEdit95.Text);
   i2:=StrtoFloat(Form1.WebEdit96.Text);
   s:=i1*i2;
  Form1.WebEdit97.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);

   i1:=StrtoFloat(Form1.WebEdit84.Text);
   i2:=StrtoFloat(Form1.WebEdit89.Text);
   i3:=StrtoFloat(Form1.WebEdit93.Text);
   i4:=StrtoFloat(Form1.WebEdit97.Text);
   s:=i1+i2+i3+i4;
  Form1.WebEdit98.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   i1:=StrtoFloat(Form1.WebEdit101.Text);
   i2:=StrtoFloat(Form1.WebEdit104.Text);
   s:=i1*i2;
  Form1.WebEdit99.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   i1:=StrtoFloat(Form1.WebEdit99.Text);
   i2:=StrtoFloat(Form1.WebEdit98.Text);
   s:=i1+i2;
  Form1.WebEdit105.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   i1:=StrtoFloat(Form1.WebEdit105.Text);
   i2:=StrtoFloat(Form1.WebEdit106.Text);
   i3:=StrtoFloat(Form1.WebEdit112.Text);
   s:=i1-i2+i3;
  Form1.WebEdit113.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
end;

procedure TForm1.WebBitBtn1Click(Sender: TObject);
var  s, i1, i2, i3, i4                        : Real;
begin
Sprawdz;
  i1:=StrtoFloat(Form1.WebEdit6.Text);
  i2:=StrtoFloat(Form1.WebEdit10.Text);
   s:=i1-i2;
  Form1.WebEdit16.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit16.Text);
  i2:=StrtoFloat(Form1.WebEdit17.Text);
   s:=i1-i2;
  Form1.WebEdit18.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit18.Text);
  i2:=StrtoFloat(Form1.WebEdit31.Text);
  i3:=StrtoFloat(Form1.WebEdit32.Text);
  i4:=StrtoFloat(Form1.WebEdit1.Text);
   s:=i1-i2-i3-i4;
  Form1.WebEdit34.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   i1:=StrtoFloat(Form1.WebEdit34.Text);
  i2:=StrtoFloat(Form1.WebEdit33.Text);
   s:=i1-i2;
  Form1.WebEdit35.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  Form1.WebEdit7.Text:= Form1.WebEdit35.Text;
  Form1.WebEdit14.Text:= Form1.WebEdit33.Text;
  Form1.WebEdit15.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text));
  Form1.WebEdit85.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text));
  Form1.WebEdit22.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+1);
  Form1.WebEdit86.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+1);
  Form1.WebEdit49.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+2);
  Form1.WebEdit90.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+2);
  Form1.WebEdit60.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+3);
  Form1.WebEdit94.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+3);
  Form1.WebEdit71.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+4);
  Form1.WebEdit100.Text:= InttoStr(StrtoInt(Form1.WebComboBox7.Text)+4);
 Form1.WebPageControl1.SelectNextPage(true);

end;


procedure TForm1.WebBitBtn2Click(Sender: TObject);
var  s, i1, i2, i3, i4, i5                        : Real;

begin
Sprawdz;
  i1:=StrtoFloat(Form1.WebEdit7.Text);
  i2:=StrtoFloat(Form1.WebEdit8.Text);
  i3:=StrtoFloat(Form1.WebEdit9.Text);
  i4:=StrtoFloat(Form1.WebEdit11.Text);
  i5:=StrtoFloat(Form1.WebEdit12.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit13.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit23.Text);
  i2:=StrtoFloat(Form1.WebEdit24.Text);
  i3:=StrtoFloat(Form1.WebEdit25.Text);
  i4:=StrtoFloat(Form1.WebEdit26.Text);
  i5:=StrtoFloat(Form1.WebEdit27.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit28.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit50.Text);
  i2:=StrtoFloat(Form1.WebEdit51.Text);
  i3:=StrtoFloat(Form1.WebEdit52.Text);
  i4:=StrtoFloat(Form1.WebEdit53.Text);
  i5:=StrtoFloat(Form1.WebEdit54.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit55.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit61.Text);
  i2:=StrtoFloat(Form1.WebEdit62.Text);
  i3:=StrtoFloat(Form1.WebEdit63.Text);
  i4:=StrtoFloat(Form1.WebEdit64.Text);
  i5:=StrtoFloat(Form1.WebEdit65.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit66.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit72.Text);
  i2:=StrtoFloat(Form1.WebEdit73.Text);
  i3:=StrtoFloat(Form1.WebEdit74.Text);
  i4:=StrtoFloat(Form1.WebEdit75.Text);
  i5:=StrtoFloat(Form1.WebEdit76.Text);
   s:=i1+i2+i3-i4+i5;
  Form1.WebEdit77.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);

  i1:=StrtoFloat(Form1.WebEdit13.Text);
  i2:=StrtoFloat(Form1.WebEdit14.Text);
  i3:=StrtoFloat(Form1.WebEdit19.Text);
  i4:=StrtoFloat(Form1.WebEdit20.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit21.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit28.Text);
  i2:=StrtoFloat(Form1.WebEdit29.Text);
  i3:=StrtoFloat(Form1.WebEdit30.Text);
  i4:=StrtoFloat(Form1.WebEdit47.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit48.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit55.Text);
  i2:=StrtoFloat(Form1.WebEdit56.Text);
  i3:=StrtoFloat(Form1.WebEdit57.Text);
  i4:=StrtoFloat(Form1.WebEdit58.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit59.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit66.Text);
  i2:=StrtoFloat(Form1.WebEdit67.Text);
  i3:=StrtoFloat(Form1.WebEdit68.Text);
  i4:=StrtoFloat(Form1.WebEdit69.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit70.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit77.Text);
  i2:=StrtoFloat(Form1.WebEdit78.Text);
  i3:=StrtoFloat(Form1.WebEdit79.Text);
  i4:=StrtoFloat(Form1.WebEdit80.Text);
   s:=i1+i2-i3+i4;
  Form1.WebEdit81.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  Form1.WebEdit102.Text:=  Form1.WebEdit81.Text;
  Form1.WebEdit83.Text:=  Form1.WebEdit21.Text;
  Form1.WebEdit88.Text:=  Form1.WebEdit48.Text;
  Form1.WebEdit92.Text:=  Form1.WebEdit59.Text;
  Form1.WebEdit96.Text:=  Form1.WebEdit70.Text;
 Form1.WebPageControl1.SelectNextPage(true);
end;

procedure TForm1.WebBitBtn3Click(Sender: TObject);
var  s, i1, i2, i3, i4, i5                        : Real;

begin
Sprawdz;
  Form1.WebEdit36.Text:=Form1.WebEdit43.Text;

  i1:=StrtoFloat(Form1.WebEdit39.Text);
  i2:=StrtoFloat(Form1.WebEdit40.Text);
   s:=i1-i2;
  Form1.WebEdit41.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  Form1.WebEdit37.Text:=Form1.WebEdit41.Text;
  i1:=StrtoFloat(Form1.WebEdit36.Text);
  i2:=StrtoFloat(Form1.WebEdit37.Text);
   s:=i1+i2;
  Form1.WebEdit38.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit41.Text);
  i2:=StrtoFloat(Form1.WebEdit44.Text);
   s:=i1*i2;
  Form1.WebEdit42.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit45.Text);
  i2:=StrtoFloat(Form1.WebEdit46.Text);
   s:=i1+i2;
  Form1.WebEdit2.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit43.Text);
  i2:=StrtoFloat(Form1.WebEdit45.Text);
   s:=i1*i2/100;
//   ShowMessage('s = '+FloattoStr(s));
  Form1.WebEdit3.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit38.Text);
  i2:=StrtoFloat(Form1.WebEdit46.Text);
   s:=i1*i2/100;
//   ShowMessage('s = '+FloattoStr(s));
   Form1.WebEdit4.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
  i1:=StrtoFloat(Form1.WebEdit3.Text);
  i2:=StrtoFloat(Form1.WebEdit4.Text);
   s:=i1+i2;
  Form1.WebEdit5.Text:=FloattoStr(SimpleRoundTo (s * 100, 0) / 100);
   Form1.WebPageControl1.SelectNextPage(true);
end;


procedure TForm1.WebBitBtn4Click(Sender: TObject);
begin
Sprawdz;
Przelicz;
end;

procedure TForm1.WebComboBox1Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebComboBox2Change(Sender: TObject);
var  DIC                                            : String;
     i                                              : Integer;
begin
Przelicz;
end;

procedure TForm1.WebComboBox3Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebComboBox4Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebComboBox5Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebComboBox6Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit10Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit11Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit11KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit11.Text='' then Exit;
   Val(WebEdit11.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit11.Text := ''}
end;

procedure TForm1.WebEdit12Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit12KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit12.Text='' then Exit;
   Val(WebEdit12.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit12.Text := ''}
end;

procedure TForm1.WebEdit13Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit13KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit13.Text='' then Exit;
   Val(WebEdit13.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit13.Text := ''}
end;

procedure TForm1.WebEdit14Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit14KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit14.Text='' then Exit;
   Val(WebEdit14.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit14.Text := ''}
end;

procedure TForm1.WebEdit15Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit15KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit15.Text='' then Exit;
   Val(WebEdit15.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit15.Text := ''}
end;

procedure TForm1.WebEdit17Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit18Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit19Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit19KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit19.Text='' then Exit;
   Val(WebEdit19.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit19.Text := '' }
end;

procedure TForm1.WebEdit1Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit20KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit20.Text='' then Exit;
   Val(WebEdit20.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit20.Text := ''}
end;

procedure TForm1.WebEdit21KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit21.Text='' then Exit;
   Val(WebEdit21.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit21.Text := ''}
end;

procedure TForm1.WebEdit22KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit22.Text='' then Exit;
   Val(WebEdit22.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit22.Text := ''}
end;

procedure TForm1.WebEdit23KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit23.Text='' then Exit;
   Val(WebEdit23.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit23.Text := ''}
end;

procedure TForm1.WebEdit25KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit25.Text='' then Exit;
   Val(WebEdit25.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit25.Text := ''}
end;

procedure TForm1.WebEdit27KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit27.Text='' then Exit;
   Val(WebEdit27.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit27.Text := ''}
end;

procedure TForm1.WebEdit28KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit28.Text='' then Exit;
   Val(WebEdit28.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit28.Text := ''}
end;

procedure TForm1.WebEdit29KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit29.Text='' then Exit;
   Val(WebEdit29.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit29.Text := ''}
end;

procedure TForm1.WebEdit2Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit2KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit2.Text='' then Exit;
   Val(WebEdit2.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit2.Text := ''}
end;

procedure TForm1.WebEdit30KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit30.Text='' then Exit;
   Val(WebEdit30.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit30.Text := ''}
end;

procedure TForm1.WebEdit3Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit3KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit3.Text='' then Exit;
   Val(WebEdit3.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit3.Text := ''}
end;

procedure TForm1.WebEdit4Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit5Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit5KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit5.Text='' then Exit;
   Val(WebEdit5.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit5.Text := ''   }
end;

procedure TForm1.WebEdit6Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit7Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit7KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit7.Text='' then Exit;
   Val(WebEdit7.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit7.Text := ''}
end;

procedure TForm1.WebEdit8Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit8KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
{  if WebEdit8.Text='' then Exit;
   Val(WebEdit8.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit8.Text := ''}
end;

procedure TForm1.WebEdit9Change(Sender: TObject);
begin
Przelicz;
end;

procedure TForm1.WebEdit9KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
{  if WebEdit9.Text='' then Exit;
   Val(WebEdit9.Text, nett, code);
   if code = 0 then begin
    Przelicz;
   end else WebEdit9.Text := ''}
end;

procedure TForm1.WebFormCreate(Sender: TObject);
//  procedure AfterCreate(AForm: TObject);
//  begin
   //    if Assigned(frm) and (frm is TSubForm1) then
//  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

// frm :=  TSubForm1.CreateNew(HostPanel.ElementID, @WebFormCreate);
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel88 := TLabel.Create(Self);
  WebLabel90 := TLabel.Create(Self);
  WebLabel92 := TLabel.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WebGroupBox3 := TGroupBox.Create(Self);
  WebLabel45 := TLabel.Create(Self);
  WebLabel47 := TLabel.Create(Self);
  WebLabel48 := TLabel.Create(Self);
  WebLabel50 := TLabel.Create(Self);
  WebLabel51 := TLabel.Create(Self);
  WebLabel52 := TLabel.Create(Self);
  WebLabel53 := TLabel.Create(Self);
  WebLabel54 := TLabel.Create(Self);
  WebLabel55 := TLabel.Create(Self);
  WebLabel56 := TLabel.Create(Self);
  WebLabel57 := TLabel.Create(Self);
  WebLabel58 := TLabel.Create(Self);
  WebLabel59 := TLabel.Create(Self);
  WebLabel60 := TLabel.Create(Self);
  WebLabel61 := TLabel.Create(Self);
  WebLabel64 := TLabel.Create(Self);
  WebLabel65 := TLabel.Create(Self);
  WebLabel46 := TLabel.Create(Self);
  WebLabel72 := TLabel.Create(Self);
  WebLabel73 := TLabel.Create(Self);
  WebLabel81 := TLabel.Create(Self);
  WebLabel82 := TLabel.Create(Self);
  WebLabel83 := TLabel.Create(Self);
  WebLabel93 := TLabel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit31 := TEdit.Create(Self);
  WebEdit32 := TEdit.Create(Self);
  WebEdit34 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebComboBox7 := TComboBox.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit33 := TEdit.Create(Self);
  WebEdit35 := TEdit.Create(Self);
  WebBitBtn1 := TBitBtn.Create(Self);
  WebEdit114 := TEdit.Create(Self);
  WebPageControl1Sheet2 := TTabSheet.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebLabel94 := TLabel.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit15 := TEdit.Create(Self);
  WebEdit19 := TEdit.Create(Self);
  WebEdit20 := TEdit.Create(Self);
  WebEdit21 := TEdit.Create(Self);
  WebEdit22 := TEdit.Create(Self);
  WebEdit23 := TEdit.Create(Self);
  WebEdit24 := TEdit.Create(Self);
  WebEdit25 := TEdit.Create(Self);
  WebEdit26 := TEdit.Create(Self);
  WebEdit27 := TEdit.Create(Self);
  WebEdit28 := TEdit.Create(Self);
  WebEdit29 := TEdit.Create(Self);
  WebEdit30 := TEdit.Create(Self);
  WebEdit47 := TEdit.Create(Self);
  WebEdit48 := TEdit.Create(Self);
  WebEdit49 := TEdit.Create(Self);
  WebEdit50 := TEdit.Create(Self);
  WebEdit51 := TEdit.Create(Self);
  WebEdit52 := TEdit.Create(Self);
  WebEdit53 := TEdit.Create(Self);
  WebEdit54 := TEdit.Create(Self);
  WebEdit55 := TEdit.Create(Self);
  WebEdit56 := TEdit.Create(Self);
  WebEdit57 := TEdit.Create(Self);
  WebEdit58 := TEdit.Create(Self);
  WebEdit59 := TEdit.Create(Self);
  WebEdit60 := TEdit.Create(Self);
  WebEdit61 := TEdit.Create(Self);
  WebEdit62 := TEdit.Create(Self);
  WebEdit63 := TEdit.Create(Self);
  WebEdit64 := TEdit.Create(Self);
  WebEdit65 := TEdit.Create(Self);
  WebEdit66 := TEdit.Create(Self);
  WebEdit67 := TEdit.Create(Self);
  WebEdit68 := TEdit.Create(Self);
  WebEdit69 := TEdit.Create(Self);
  WebEdit70 := TEdit.Create(Self);
  WebEdit71 := TEdit.Create(Self);
  WebEdit72 := TEdit.Create(Self);
  WebEdit73 := TEdit.Create(Self);
  WebEdit74 := TEdit.Create(Self);
  WebEdit75 := TEdit.Create(Self);
  WebEdit76 := TEdit.Create(Self);
  WebEdit77 := TEdit.Create(Self);
  WebEdit78 := TEdit.Create(Self);
  WebEdit79 := TEdit.Create(Self);
  WebEdit80 := TEdit.Create(Self);
  WebEdit81 := TEdit.Create(Self);
  WebBitBtn2 := TBitBtn.Create(Self);
  WebEdit115 := TEdit.Create(Self);
  WebPageControl1Sheet3 := TTabSheet.Create(Self);
  WebGroupBox4 := TGroupBox.Create(Self);
  WebLabel66 := TLabel.Create(Self);
  WebLabel68 := TLabel.Create(Self);
  WebLabel71 := TLabel.Create(Self);
  WebLabel75 := TLabel.Create(Self);
  WebLabel77 := TLabel.Create(Self);
  WebLabel79 := TLabel.Create(Self);
  WebLabel80 := TLabel.Create(Self);
  WebLabel85 := TLabel.Create(Self);
  WebLabel87 := TLabel.Create(Self);
  WebLabel89 := TLabel.Create(Self);
  WebLabel91 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel95 := TLabel.Create(Self);
  WebImageControl4 := TImageControl.Create(Self);
  WebEdit36 := TEdit.Create(Self);
  WebEdit37 := TEdit.Create(Self);
  WebEdit38 := TEdit.Create(Self);
  WebEdit39 := TEdit.Create(Self);
  WebEdit40 := TEdit.Create(Self);
  WebEdit41 := TEdit.Create(Self);
  WebEdit42 := TEdit.Create(Self);
  WebEdit43 := TEdit.Create(Self);
  WebEdit44 := TEdit.Create(Self);
  WebEdit45 := TEdit.Create(Self);
  WebEdit46 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebBitBtn3 := TBitBtn.Create(Self);
  WebEdit118 := TEdit.Create(Self);
  WebPageControl1Sheet4 := TTabSheet.Create(Self);
  WebGroupBox2 := TGroupBox.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebLabel39 := TLabel.Create(Self);
  WebLabel40 := TLabel.Create(Self);
  WebLabel41 := TLabel.Create(Self);
  WebLabel42 := TLabel.Create(Self);
  WebLabel43 := TLabel.Create(Self);
  WebLabel44 := TLabel.Create(Self);
  WebLabel49 := TLabel.Create(Self);
  WebLabel62 := TLabel.Create(Self);
  WebLabel63 := TLabel.Create(Self);
  WebLabel67 := TLabel.Create(Self);
  WebLabel69 := TLabel.Create(Self);
  WebLabel70 := TLabel.Create(Self);
  WebLabel74 := TLabel.Create(Self);
  WebLabel76 := TLabel.Create(Self);
  WebLabel78 := TLabel.Create(Self);
  WebLabel84 := TLabel.Create(Self);
  WebLabel86 := TLabel.Create(Self);
  WebLabel96 := TLabel.Create(Self);
  WebEdit82 := TEdit.Create(Self);
  WebEdit83 := TEdit.Create(Self);
  WebEdit84 := TEdit.Create(Self);
  WebEdit85 := TEdit.Create(Self);
  WebEdit86 := TEdit.Create(Self);
  WebEdit87 := TEdit.Create(Self);
  WebEdit88 := TEdit.Create(Self);
  WebEdit89 := TEdit.Create(Self);
  WebEdit90 := TEdit.Create(Self);
  WebEdit91 := TEdit.Create(Self);
  WebEdit92 := TEdit.Create(Self);
  WebEdit93 := TEdit.Create(Self);
  WebEdit94 := TEdit.Create(Self);
  WebEdit95 := TEdit.Create(Self);
  WebEdit96 := TEdit.Create(Self);
  WebEdit97 := TEdit.Create(Self);
  WebEdit98 := TEdit.Create(Self);
  WebEdit99 := TEdit.Create(Self);
  WebEdit100 := TEdit.Create(Self);
  WebEdit101 := TEdit.Create(Self);
  WebEdit102 := TEdit.Create(Self);
  WebEdit103 := TEdit.Create(Self);
  WebEdit104 := TEdit.Create(Self);
  WebEdit105 := TEdit.Create(Self);
  WebEdit106 := TEdit.Create(Self);
  WebEdit107 := TEdit.Create(Self);
  WebEdit108 := TEdit.Create(Self);
  WebEdit109 := TEdit.Create(Self);
  WebEdit110 := TEdit.Create(Self);
  WebEdit111 := TEdit.Create(Self);
  WebEdit112 := TEdit.Create(Self);
  WebEdit113 := TEdit.Create(Self);
  WebBitBtn4 := TBitBtn.Create(Self);
  WebEdit117 := TEdit.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel88.BeforeLoadDFMValues;
  WebLabel90.BeforeLoadDFMValues;
  WebLabel92.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WebGroupBox3.BeforeLoadDFMValues;
  WebLabel45.BeforeLoadDFMValues;
  WebLabel47.BeforeLoadDFMValues;
  WebLabel48.BeforeLoadDFMValues;
  WebLabel50.BeforeLoadDFMValues;
  WebLabel51.BeforeLoadDFMValues;
  WebLabel52.BeforeLoadDFMValues;
  WebLabel53.BeforeLoadDFMValues;
  WebLabel54.BeforeLoadDFMValues;
  WebLabel55.BeforeLoadDFMValues;
  WebLabel56.BeforeLoadDFMValues;
  WebLabel57.BeforeLoadDFMValues;
  WebLabel58.BeforeLoadDFMValues;
  WebLabel59.BeforeLoadDFMValues;
  WebLabel60.BeforeLoadDFMValues;
  WebLabel61.BeforeLoadDFMValues;
  WebLabel64.BeforeLoadDFMValues;
  WebLabel65.BeforeLoadDFMValues;
  WebLabel46.BeforeLoadDFMValues;
  WebLabel72.BeforeLoadDFMValues;
  WebLabel73.BeforeLoadDFMValues;
  WebLabel81.BeforeLoadDFMValues;
  WebLabel82.BeforeLoadDFMValues;
  WebLabel83.BeforeLoadDFMValues;
  WebLabel93.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit31.BeforeLoadDFMValues;
  WebEdit32.BeforeLoadDFMValues;
  WebEdit34.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebComboBox7.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit33.BeforeLoadDFMValues;
  WebEdit35.BeforeLoadDFMValues;
  WebBitBtn1.BeforeLoadDFMValues;
  WebEdit114.BeforeLoadDFMValues;
  WebPageControl1Sheet2.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel94.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  WebEdit19.BeforeLoadDFMValues;
  WebEdit20.BeforeLoadDFMValues;
  WebEdit21.BeforeLoadDFMValues;
  WebEdit22.BeforeLoadDFMValues;
  WebEdit23.BeforeLoadDFMValues;
  WebEdit24.BeforeLoadDFMValues;
  WebEdit25.BeforeLoadDFMValues;
  WebEdit26.BeforeLoadDFMValues;
  WebEdit27.BeforeLoadDFMValues;
  WebEdit28.BeforeLoadDFMValues;
  WebEdit29.BeforeLoadDFMValues;
  WebEdit30.BeforeLoadDFMValues;
  WebEdit47.BeforeLoadDFMValues;
  WebEdit48.BeforeLoadDFMValues;
  WebEdit49.BeforeLoadDFMValues;
  WebEdit50.BeforeLoadDFMValues;
  WebEdit51.BeforeLoadDFMValues;
  WebEdit52.BeforeLoadDFMValues;
  WebEdit53.BeforeLoadDFMValues;
  WebEdit54.BeforeLoadDFMValues;
  WebEdit55.BeforeLoadDFMValues;
  WebEdit56.BeforeLoadDFMValues;
  WebEdit57.BeforeLoadDFMValues;
  WebEdit58.BeforeLoadDFMValues;
  WebEdit59.BeforeLoadDFMValues;
  WebEdit60.BeforeLoadDFMValues;
  WebEdit61.BeforeLoadDFMValues;
  WebEdit62.BeforeLoadDFMValues;
  WebEdit63.BeforeLoadDFMValues;
  WebEdit64.BeforeLoadDFMValues;
  WebEdit65.BeforeLoadDFMValues;
  WebEdit66.BeforeLoadDFMValues;
  WebEdit67.BeforeLoadDFMValues;
  WebEdit68.BeforeLoadDFMValues;
  WebEdit69.BeforeLoadDFMValues;
  WebEdit70.BeforeLoadDFMValues;
  WebEdit71.BeforeLoadDFMValues;
  WebEdit72.BeforeLoadDFMValues;
  WebEdit73.BeforeLoadDFMValues;
  WebEdit74.BeforeLoadDFMValues;
  WebEdit75.BeforeLoadDFMValues;
  WebEdit76.BeforeLoadDFMValues;
  WebEdit77.BeforeLoadDFMValues;
  WebEdit78.BeforeLoadDFMValues;
  WebEdit79.BeforeLoadDFMValues;
  WebEdit80.BeforeLoadDFMValues;
  WebEdit81.BeforeLoadDFMValues;
  WebBitBtn2.BeforeLoadDFMValues;
  WebEdit115.BeforeLoadDFMValues;
  WebPageControl1Sheet3.BeforeLoadDFMValues;
  WebGroupBox4.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebLabel71.BeforeLoadDFMValues;
  WebLabel75.BeforeLoadDFMValues;
  WebLabel77.BeforeLoadDFMValues;
  WebLabel79.BeforeLoadDFMValues;
  WebLabel80.BeforeLoadDFMValues;
  WebLabel85.BeforeLoadDFMValues;
  WebLabel87.BeforeLoadDFMValues;
  WebLabel89.BeforeLoadDFMValues;
  WebLabel91.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel95.BeforeLoadDFMValues;
  WebImageControl4.BeforeLoadDFMValues;
  WebEdit36.BeforeLoadDFMValues;
  WebEdit37.BeforeLoadDFMValues;
  WebEdit38.BeforeLoadDFMValues;
  WebEdit39.BeforeLoadDFMValues;
  WebEdit40.BeforeLoadDFMValues;
  WebEdit41.BeforeLoadDFMValues;
  WebEdit42.BeforeLoadDFMValues;
  WebEdit43.BeforeLoadDFMValues;
  WebEdit44.BeforeLoadDFMValues;
  WebEdit45.BeforeLoadDFMValues;
  WebEdit46.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebBitBtn3.BeforeLoadDFMValues;
  WebEdit118.BeforeLoadDFMValues;
  WebPageControl1Sheet4.BeforeLoadDFMValues;
  WebGroupBox2.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebLabel40.BeforeLoadDFMValues;
  WebLabel41.BeforeLoadDFMValues;
  WebLabel42.BeforeLoadDFMValues;
  WebLabel43.BeforeLoadDFMValues;
  WebLabel44.BeforeLoadDFMValues;
  WebLabel49.BeforeLoadDFMValues;
  WebLabel62.BeforeLoadDFMValues;
  WebLabel63.BeforeLoadDFMValues;
  WebLabel67.BeforeLoadDFMValues;
  WebLabel69.BeforeLoadDFMValues;
  WebLabel70.BeforeLoadDFMValues;
  WebLabel74.BeforeLoadDFMValues;
  WebLabel76.BeforeLoadDFMValues;
  WebLabel78.BeforeLoadDFMValues;
  WebLabel84.BeforeLoadDFMValues;
  WebLabel86.BeforeLoadDFMValues;
  WebLabel96.BeforeLoadDFMValues;
  WebEdit82.BeforeLoadDFMValues;
  WebEdit83.BeforeLoadDFMValues;
  WebEdit84.BeforeLoadDFMValues;
  WebEdit85.BeforeLoadDFMValues;
  WebEdit86.BeforeLoadDFMValues;
  WebEdit87.BeforeLoadDFMValues;
  WebEdit88.BeforeLoadDFMValues;
  WebEdit89.BeforeLoadDFMValues;
  WebEdit90.BeforeLoadDFMValues;
  WebEdit91.BeforeLoadDFMValues;
  WebEdit92.BeforeLoadDFMValues;
  WebEdit93.BeforeLoadDFMValues;
  WebEdit94.BeforeLoadDFMValues;
  WebEdit95.BeforeLoadDFMValues;
  WebEdit96.BeforeLoadDFMValues;
  WebEdit97.BeforeLoadDFMValues;
  WebEdit98.BeforeLoadDFMValues;
  WebEdit99.BeforeLoadDFMValues;
  WebEdit100.BeforeLoadDFMValues;
  WebEdit101.BeforeLoadDFMValues;
  WebEdit102.BeforeLoadDFMValues;
  WebEdit103.BeforeLoadDFMValues;
  WebEdit104.BeforeLoadDFMValues;
  WebEdit105.BeforeLoadDFMValues;
  WebEdit106.BeforeLoadDFMValues;
  WebEdit107.BeforeLoadDFMValues;
  WebEdit108.BeforeLoadDFMValues;
  WebEdit109.BeforeLoadDFMValues;
  WebEdit110.BeforeLoadDFMValues;
  WebEdit111.BeforeLoadDFMValues;
  WebEdit112.BeforeLoadDFMValues;
  WebEdit113.BeforeLoadDFMValues;
  WebBitBtn4.BeforeLoadDFMValues;
  WebEdit117.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Left := 0;
    Top := 0;
    Width := 738;
    Height := 604;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := 14;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 2;
    WebLabel1.Top := 126;
    WebLabel1.Width := 192;
    WebLabel1.Height := 14;
    WebLabel1.Caption := 'Wycena warto'#347'ci firmy wg. DCF';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clHotLight;
    WebLabel1.Font.Height := 14;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebLabel1.Transparent := False;
    WebLabel88.SetParentComponent(Self);
    WebLabel88.Name := 'WebLabel88';
    WebLabel88.Left := 8;
    WebLabel88.Top := 406;
    WebLabel88.Width := 233;
    WebLabel88.Height := 14;
    WebLabel88.Caption := 'Kalkulator wycena firmy - Biz24.pl (c) 2020';
    WebLabel88.Color := clYellow;
    WebLabel88.Transparent := False;
    WebLabel90.SetParentComponent(Self);
    WebLabel90.Name := 'WebLabel90';
    WebLabel90.Left := 16;
    WebLabel90.Top := 414;
    WebLabel90.Width := 233;
    WebLabel90.Height := 14;
    WebLabel90.Caption := 'Kalkulator wycena firmy - Biz24.pl (c) 2020';
    WebLabel90.Color := clYellow;
    WebLabel90.Transparent := False;
    WebLabel92.SetParentComponent(Self);
    WebLabel92.Name := 'WebLabel92';
    WebLabel92.Left := 7;
    WebLabel92.Top := 588;
    WebLabel92.Width := 136;
    WebLabel92.Height := 14;
    WebLabel92.Caption := 'Biz24 Copyright (c) 2020';
    WebLabel92.Font.Charset := DEFAULT_CHARSET;
    WebLabel92.Font.Color := clBlue;
    WebLabel92.Font.Height := -12;
    WebLabel92.Font.Name := 'Tahoma';
    WebLabel92.Font.Style := [];
    WebLabel92.ParentFont := False;
    WebLabel92.Transparent := False;
    WebImageControl2.SetParentComponent(Self);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 0;
    WebImageControl2.Top := 0;
    WebImageControl2.Width := 251;
    WebImageControl2.Height := 121;
    WebImageControl2.ChildOrder := 12;
    WebImageControl2.Picture.LoadFromFile('Factor.WebImageControl2.Picture.jpg');
    WebPageControl1.SetParentComponent(Self);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 1;
    WebPageControl1.Top := 146;
    WebPageControl1.Width := 729;
    WebPageControl1.Height := 441;
    WebPageControl1.ChildOrder := 2;
    WebPageControl1.Font.Charset := DEFAULT_CHARSET;
    WebPageControl1.Font.Color := clWindowText;
    WebPageControl1.Font.Height := 11;
    WebPageControl1.Font.Name := 'Tahoma';
    WebPageControl1.Font.Style := [];
    WebPageControl1.TabIndex := 0;
    WebPageControl1.ParentFont := False;
    WebPageControl1.SelectedColor := clSilver;
    WebPageControl1.TabOrder := 0;
    WebPageControl1Sheet1.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 729;
    WebPageControl1Sheet1.Height := 421;
    WebPageControl1Sheet1.Caption := 'Dane podstawowe';
    WebGroupBox3.SetParentComponent(WebPageControl1Sheet1);
    WebGroupBox3.Name := 'WebGroupBox3';
    WebGroupBox3.Left := 3;
    WebGroupBox3.Top := 3;
    WebGroupBox3.Width := 723;
    WebGroupBox3.Height := 415;
    WebGroupBox3.ChildOrder := 27;
    WebGroupBox3.Color := clWhite;
    WebLabel45.SetParentComponent(WebGroupBox3);
    WebLabel45.Name := 'WebLabel45';
    WebLabel45.Left := 18;
    WebLabel45.Top := 31;
    WebLabel45.Width := 68;
    WebLabel45.Height := 13;
    WebLabel45.Caption := 'Rok bazowy';
    WebLabel45.Font.Charset := DEFAULT_CHARSET;
    WebLabel45.Font.Color := clWindowText;
    WebLabel45.Font.Height := -11;
    WebLabel45.Font.Name := 'Tahoma';
    WebLabel45.Font.Style := [fsBold];
    WebLabel45.ParentFont := False;
    WebLabel47.SetParentComponent(WebGroupBox3);
    WebLabel47.Name := 'WebLabel47';
    WebLabel47.Left := 18;
    WebLabel47.Top := 60;
    WebLabel47.Width := 44;
    WebLabel47.Height := 13;
    WebLabel47.Caption := 'Przych'#243'd';
    WebLabel47.Font.Charset := DEFAULT_CHARSET;
    WebLabel47.Font.Color := clWindowText;
    WebLabel47.Font.Height := -11;
    WebLabel47.Font.Name := 'Tahoma';
    WebLabel47.Font.Style := [];
    WebLabel47.ParentFont := False;
    WebLabel48.SetParentComponent(WebGroupBox3);
    WebLabel48.Name := 'WebLabel48';
    WebLabel48.Left := 316;
    WebLabel48.Top := 60;
    WebLabel48.Width := 18;
    WebLabel48.Height := 13;
    WebLabel48.Caption := 'PLN';
    WebLabel48.Font.Charset := DEFAULT_CHARSET;
    WebLabel48.Font.Color := clWindowText;
    WebLabel48.Font.Height := -11;
    WebLabel48.Font.Name := 'Tahoma';
    WebLabel48.Font.Style := [];
    WebLabel48.ParentFont := False;
    WebLabel50.SetParentComponent(WebGroupBox3);
    WebLabel50.Name := 'WebLabel50';
    WebLabel50.Left := 18;
    WebLabel50.Top := 86;
    WebLabel50.Width := 85;
    WebLabel50.Height := 13;
    WebLabel50.Caption := 'Koszty materia'#243'w';
    WebLabel50.Font.Charset := DEFAULT_CHARSET;
    WebLabel50.Font.Color := clWindowText;
    WebLabel50.Font.Height := -11;
    WebLabel50.Font.Name := 'Tahoma';
    WebLabel50.Font.Style := [];
    WebLabel50.ParentFont := False;
    WebLabel51.SetParentComponent(WebGroupBox3);
    WebLabel51.Name := 'WebLabel51';
    WebLabel51.Left := 316;
    WebLabel51.Top := 86;
    WebLabel51.Width := 18;
    WebLabel51.Height := 13;
    WebLabel51.Caption := 'PLN';
    WebLabel51.Font.Charset := DEFAULT_CHARSET;
    WebLabel51.Font.Color := clWindowText;
    WebLabel51.Font.Height := -11;
    WebLabel51.Font.Name := 'Tahoma';
    WebLabel51.Font.Style := [];
    WebLabel51.ParentFont := False;
    WebLabel52.SetParentComponent(WebGroupBox3);
    WebLabel52.Name := 'WebLabel52';
    WebLabel52.Left := 316;
    WebLabel52.Top := 112;
    WebLabel52.Width := 18;
    WebLabel52.Height := 13;
    WebLabel52.Caption := 'PLN';
    WebLabel52.Font.Charset := DEFAULT_CHARSET;
    WebLabel52.Font.Color := clWindowText;
    WebLabel52.Font.Height := -11;
    WebLabel52.Font.Name := 'Tahoma';
    WebLabel52.Font.Style := [];
    WebLabel52.ParentFont := False;
    WebLabel53.SetParentComponent(WebGroupBox3);
    WebLabel53.Name := 'WebLabel53';
    WebLabel53.Left := 18;
    WebLabel53.Top := 112;
    WebLabel53.Width := 27;
    WebLabel53.Height := 13;
    WebLabel53.Caption := 'DB-1';
    WebLabel53.Font.Charset := DEFAULT_CHARSET;
    WebLabel53.Font.Color := clWindowText;
    WebLabel53.Font.Height := -11;
    WebLabel53.Font.Name := 'Tahoma';
    WebLabel53.Font.Style := [fsBold];
    WebLabel53.ParentFont := False;
    WebLabel54.SetParentComponent(WebGroupBox3);
    WebLabel54.Name := 'WebLabel54';
    WebLabel54.Left := 316;
    WebLabel54.Top := 138;
    WebLabel54.Width := 18;
    WebLabel54.Height := 13;
    WebLabel54.Caption := 'PLN';
    WebLabel54.Font.Charset := DEFAULT_CHARSET;
    WebLabel54.Font.Color := clWindowText;
    WebLabel54.Font.Height := -11;
    WebLabel54.Font.Name := 'Tahoma';
    WebLabel54.Font.Style := [];
    WebLabel54.ParentFont := False;
    WebLabel55.SetParentComponent(WebGroupBox3);
    WebLabel55.Name := 'WebLabel55';
    WebLabel55.Left := 18;
    WebLabel55.Top := 138;
    WebLabel55.Width := 78;
    WebLabel55.Height := 13;
    WebLabel55.Caption := 'Koszty osobowe';
    WebLabel55.Font.Charset := DEFAULT_CHARSET;
    WebLabel55.Font.Color := clWindowText;
    WebLabel55.Font.Height := -11;
    WebLabel55.Font.Name := 'Tahoma';
    WebLabel55.Font.Style := [];
    WebLabel55.ParentFont := False;
    WebLabel56.SetParentComponent(WebGroupBox3);
    WebLabel56.Name := 'WebLabel56';
    WebLabel56.Left := 316;
    WebLabel56.Top := 164;
    WebLabel56.Width := 18;
    WebLabel56.Height := 13;
    WebLabel56.Caption := 'PLN';
    WebLabel56.Font.Charset := DEFAULT_CHARSET;
    WebLabel56.Font.Color := clWindowText;
    WebLabel56.Font.Height := -11;
    WebLabel56.Font.Name := 'Tahoma';
    WebLabel56.Font.Style := [];
    WebLabel56.ParentFont := False;
    WebLabel57.SetParentComponent(WebGroupBox3);
    WebLabel57.Name := 'WebLabel57';
    WebLabel57.Left := 18;
    WebLabel57.Top := 164;
    WebLabel57.Width := 27;
    WebLabel57.Height := 13;
    WebLabel57.Caption := 'DB-2';
    WebLabel57.Font.Charset := DEFAULT_CHARSET;
    WebLabel57.Font.Color := clWindowText;
    WebLabel57.Font.Height := -11;
    WebLabel57.Font.Name := 'Tahoma';
    WebLabel57.Font.Style := [fsBold];
    WebLabel57.ParentFont := False;
    WebLabel58.SetParentComponent(WebGroupBox3);
    WebLabel58.Name := 'WebLabel58';
    WebLabel58.Left := 316;
    WebLabel58.Top := 190;
    WebLabel58.Width := 18;
    WebLabel58.Height := 13;
    WebLabel58.Caption := 'PLN';
    WebLabel58.Font.Charset := DEFAULT_CHARSET;
    WebLabel58.Font.Color := clWindowText;
    WebLabel58.Font.Height := -11;
    WebLabel58.Font.Name := 'Tahoma';
    WebLabel58.Font.Style := [];
    WebLabel58.ParentFont := False;
    WebLabel59.SetParentComponent(WebGroupBox3);
    WebLabel59.Name := 'WebLabel59';
    WebLabel59.Left := 18;
    WebLabel59.Top := 190;
    WebLabel59.Width := 84;
    WebLabel59.Height := 13;
    WebLabel59.Caption := 'Koszty sprzedazy';
    WebLabel59.Font.Charset := DEFAULT_CHARSET;
    WebLabel59.Font.Color := clWindowText;
    WebLabel59.Font.Height := -11;
    WebLabel59.Font.Name := 'Tahoma';
    WebLabel59.Font.Style := [];
    WebLabel59.ParentFont := False;
    WebLabel60.SetParentComponent(WebGroupBox3);
    WebLabel60.Name := 'WebLabel60';
    WebLabel60.Left := 18;
    WebLabel60.Top := 216;
    WebLabel60.Width := 67;
    WebLabel60.Height := 13;
    WebLabel60.Caption := 'Koszty og'#243'lne';
    WebLabel60.Font.Charset := DEFAULT_CHARSET;
    WebLabel60.Font.Color := clWindowText;
    WebLabel60.Font.Height := -11;
    WebLabel60.Font.Name := 'Tahoma';
    WebLabel60.Font.Style := [];
    WebLabel60.ParentFont := False;
    WebLabel61.SetParentComponent(WebGroupBox3);
    WebLabel61.Name := 'WebLabel61';
    WebLabel61.Left := 316;
    WebLabel61.Top := 216;
    WebLabel61.Width := 18;
    WebLabel61.Height := 13;
    WebLabel61.Caption := 'PLN';
    WebLabel61.Font.Charset := DEFAULT_CHARSET;
    WebLabel61.Font.Color := clWindowText;
    WebLabel61.Font.Height := -11;
    WebLabel61.Font.Name := 'Tahoma';
    WebLabel61.Font.Style := [];
    WebLabel61.ParentFont := False;
    WebLabel64.SetParentComponent(WebGroupBox3);
    WebLabel64.Name := 'WebLabel64';
    WebLabel64.Left := 18;
    WebLabel64.Top := 268;
    WebLabel64.Width := 55;
    WebLabel64.Height := 13;
    WebLabel64.Caption := 'Cash Flow';
    WebLabel64.Font.Charset := DEFAULT_CHARSET;
    WebLabel64.Font.Color := clWindowText;
    WebLabel64.Font.Height := -11;
    WebLabel64.Font.Name := 'Tahoma';
    WebLabel64.Font.Style := [fsBold];
    WebLabel64.ParentFont := False;
    WebLabel65.SetParentComponent(WebGroupBox3);
    WebLabel65.Name := 'WebLabel65';
    WebLabel65.Left := 316;
    WebLabel65.Top := 268;
    WebLabel65.Width := 18;
    WebLabel65.Height := 13;
    WebLabel65.Caption := 'PLN';
    WebLabel65.Font.Charset := DEFAULT_CHARSET;
    WebLabel65.Font.Color := clWindowText;
    WebLabel65.Font.Height := -11;
    WebLabel65.Font.Name := 'Tahoma';
    WebLabel65.Font.Style := [];
    WebLabel65.ParentFont := False;
    WebLabel46.SetParentComponent(WebGroupBox3);
    WebLabel46.Name := 'WebLabel46';
    WebLabel46.Left := 17;
    WebLabel46.Top := 242;
    WebLabel46.Width := 82;
    WebLabel46.Height := 13;
    WebLabel46.Caption := 'Koszty pozosta'#322'e';
    WebLabel46.Font.Charset := DEFAULT_CHARSET;
    WebLabel46.Font.Color := clWindowText;
    WebLabel46.Font.Height := -11;
    WebLabel46.Font.Name := 'Tahoma';
    WebLabel46.Font.Style := [];
    WebLabel46.ParentFont := False;
    WebLabel72.SetParentComponent(WebGroupBox3);
    WebLabel72.Name := 'WebLabel72';
    WebLabel72.Left := 315;
    WebLabel72.Top := 242;
    WebLabel72.Width := 18;
    WebLabel72.Height := 13;
    WebLabel72.Caption := 'PLN';
    WebLabel72.Font.Charset := DEFAULT_CHARSET;
    WebLabel72.Font.Color := clWindowText;
    WebLabel72.Font.Height := -11;
    WebLabel72.Font.Name := 'Tahoma';
    WebLabel72.Font.Style := [];
    WebLabel72.ParentFont := False;
    WebLabel73.SetParentComponent(WebGroupBox3);
    WebLabel73.Name := 'WebLabel73';
    WebLabel73.Left := 17;
    WebLabel73.Top := 294;
    WebLabel73.Width := 60;
    WebLabel73.Height := 13;
    WebLabel73.Caption := 'Amortyzacja';
    WebLabel73.Font.Charset := DEFAULT_CHARSET;
    WebLabel73.Font.Color := clWindowText;
    WebLabel73.Font.Height := -11;
    WebLabel73.Font.Name := 'Tahoma';
    WebLabel73.Font.Style := [];
    WebLabel73.ParentFont := False;
    WebLabel81.SetParentComponent(WebGroupBox3);
    WebLabel81.Name := 'WebLabel81';
    WebLabel81.Left := 315;
    WebLabel81.Top := 294;
    WebLabel81.Width := 18;
    WebLabel81.Height := 13;
    WebLabel81.Caption := 'PLN';
    WebLabel81.Font.Charset := DEFAULT_CHARSET;
    WebLabel81.Font.Color := clWindowText;
    WebLabel81.Font.Height := -11;
    WebLabel81.Font.Name := 'Tahoma';
    WebLabel81.Font.Style := [];
    WebLabel81.ParentFont := False;
    WebLabel82.SetParentComponent(WebGroupBox3);
    WebLabel82.Name := 'WebLabel82';
    WebLabel82.Left := 17;
    WebLabel82.Top := 320;
    WebLabel82.Width := 35;
    WebLabel82.Height := 13;
    WebLabel82.Caption := 'Wynik';
    WebLabel82.Font.Charset := DEFAULT_CHARSET;
    WebLabel82.Font.Color := clBlue;
    WebLabel82.Font.Height := -11;
    WebLabel82.Font.Name := 'Tahoma';
    WebLabel82.Font.Style := [fsBold];
    WebLabel82.ParentFont := False;
    WebLabel83.SetParentComponent(WebGroupBox3);
    WebLabel83.Name := 'WebLabel83';
    WebLabel83.Left := 315;
    WebLabel83.Top := 320;
    WebLabel83.Width := 18;
    WebLabel83.Height := 13;
    WebLabel83.Caption := 'PLN';
    WebLabel83.Font.Charset := DEFAULT_CHARSET;
    WebLabel83.Font.Color := clWindowText;
    WebLabel83.Font.Height := -11;
    WebLabel83.Font.Name := 'Tahoma';
    WebLabel83.Font.Style := [];
    WebLabel83.ParentFont := False;
    WebLabel93.SetParentComponent(WebGroupBox3);
    WebLabel93.Name := 'WebLabel93';
    WebLabel93.Left := 95;
    WebLabel93.Top := 391;
    WebLabel93.Width := 99;
    WebLabel93.Height := 10;
    WebLabel93.Caption := '- prosz'#281' wype'#322'ni'#263' '#380#243#322'te pola';
    WebLabel93.Font.Charset := DEFAULT_CHARSET;
    WebLabel93.Font.Color := clWindowText;
    WebLabel93.Font.Height := -8;
    WebLabel93.Font.Name := 'Tahoma';
    WebLabel93.Font.Style := [];
    WebLabel93.ParentFont := False;
    WebImageControl1.SetParentComponent(WebGroupBox3);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 461;
    WebImageControl1.Top := 22;
    WebImageControl1.Width := 244;
    WebImageControl1.Height := 322;
    WebImageControl1.ChildOrder := 38;
    WebImageControl1.Picture.LoadFromFile('Factor.WebGroupBox3.WebImageControl1.Picture.jpg');
    WebEdit10.SetParentComponent(WebGroupBox3);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 242;
    WebEdit10.Top := 83;
    WebEdit10.Width := 68;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 1;
    WebEdit10.Color := clInfoBk;
    WebEdit10.Text := '1200000';
    WebEdit16.SetParentComponent(WebGroupBox3);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 242;
    WebEdit16.Top := 109;
    WebEdit16.Width := 68;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 2;
    WebEdit16.Color := 12903679;
    WebEdit16.Enabled := False;
    WebEdit16.Text := '3800000';
    WebEdit17.SetParentComponent(WebGroupBox3);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 242;
    WebEdit17.Top := 135;
    WebEdit17.Width := 68;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 3;
    WebEdit17.Color := clInfoBk;
    WebEdit17.Text := '1500000';
    WebEdit18.SetParentComponent(WebGroupBox3);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 242;
    WebEdit18.Top := 161;
    WebEdit18.Width := 68;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 4;
    WebEdit18.Color := 12903679;
    WebEdit18.Enabled := False;
    WebEdit18.Text := '2300000';
    WebEdit31.SetParentComponent(WebGroupBox3);
    WebEdit31.Name := 'WebEdit31';
    WebEdit31.Left := 242;
    WebEdit31.Top := 187;
    WebEdit31.Width := 68;
    WebEdit31.Height := 19;
    WebEdit31.ChildOrder := 5;
    WebEdit31.Color := clInfoBk;
    WebEdit31.Text := '300000';
    WebEdit32.SetParentComponent(WebGroupBox3);
    WebEdit32.Name := 'WebEdit32';
    WebEdit32.Left := 242;
    WebEdit32.Top := 213;
    WebEdit32.Width := 68;
    WebEdit32.Height := 19;
    WebEdit32.ChildOrder := 6;
    WebEdit32.Color := clInfoBk;
    WebEdit32.Text := '1400000';
    WebEdit34.SetParentComponent(WebGroupBox3);
    WebEdit34.Name := 'WebEdit34';
    WebEdit34.Left := 242;
    WebEdit34.Top := 265;
    WebEdit34.Width := 68;
    WebEdit34.Height := 19;
    WebEdit34.ChildOrder := 7;
    WebEdit34.Color := 12903679;
    WebEdit34.Enabled := False;
    WebEdit34.Text := '400000';
    WebEdit6.SetParentComponent(WebGroupBox3);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 242;
    WebEdit6.Top := 57;
    WebEdit6.Width := 68;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 8;
    WebEdit6.Color := clInfoBk;
    WebEdit6.Text := '5000000';
    WebComboBox7.SetParentComponent(WebGroupBox3);
    WebComboBox7.Name := 'WebComboBox7';
    WebComboBox7.Left := 242;
    WebComboBox7.Top := 28;
    WebComboBox7.Width := 68;
    WebComboBox7.Height := 22;
    WebComboBox7.Color := clInfoBk;
    WebComboBox7.Text := '2020';
    WebComboBox7.ItemIndex := 5;
    WebComboBox7.Items.BeginUpdate;
    try
      WebComboBox7.Items.Clear;
      WebComboBox7.Items.Add('2015');
      WebComboBox7.Items.Add('2016');
      WebComboBox7.Items.Add('2017');
      WebComboBox7.Items.Add('2018');
      WebComboBox7.Items.Add('2019');
      WebComboBox7.Items.Add('2020');
      WebComboBox7.Items.Add('2021');
      WebComboBox7.Items.Add('2022');
      WebComboBox7.Items.Add('2023');
      WebComboBox7.Items.Add('2024');
      WebComboBox7.Items.Add('2025'#11);
      WebComboBox7.Items.Add('');
    finally
      WebComboBox7.Items.EndUpdate;
    end;
    WebEdit1.SetParentComponent(WebGroupBox3);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 241;
    WebEdit1.Top := 239;
    WebEdit1.Width := 68;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 7;
    WebEdit1.Color := clInfoBk;
    WebEdit1.Text := '200000';
    WebEdit33.SetParentComponent(WebGroupBox3);
    WebEdit33.Name := 'WebEdit33';
    WebEdit33.Left := 241;
    WebEdit33.Top := 291;
    WebEdit33.Width := 68;
    WebEdit33.Height := 19;
    WebEdit33.ChildOrder := 7;
    WebEdit33.Color := clInfoBk;
    WebEdit33.Text := '100000';
    WebEdit35.SetParentComponent(WebGroupBox3);
    WebEdit35.Name := 'WebEdit35';
    WebEdit35.Left := 241;
    WebEdit35.Top := 317;
    WebEdit35.Width := 68;
    WebEdit35.Height := 19;
    WebEdit35.ChildOrder := 7;
    WebEdit35.Color := 12903679;
    WebEdit35.Enabled := False;
    WebEdit35.Text := '300000';
    WebBitBtn1.SetParentComponent(WebGroupBox3);
    WebBitBtn1.Name := 'WebBitBtn1';
    WebBitBtn1.Left := 576;
    WebBitBtn1.Top := 366;
    WebBitBtn1.Width := 129;
    WebBitBtn1.Height := 37;
    WebBitBtn1.Caption := 'Cash Flow >>';
    WebBitBtn1.Color := clBtnFace;
    WebBitBtn1.Glyph.LoadFromFile('Factor.WebGroupBox3.WebBitBtn1.Glyph.bmp');
    WebBitBtn1.TabOrder := 12;
    SetEvent(WebBitBtn1, Self, 'OnClick', 'WebBitBtn1Click');
    WebEdit114.SetParentComponent(WebGroupBox3);
    WebEdit114.Name := 'WebEdit114';
    WebEdit114.Left := 33;
    WebEdit114.Top := 387;
    WebEdit114.Width := 48;
    WebEdit114.Height := 19;
    WebEdit114.ChildOrder := 36;
    WebEdit114.Color := clInfoBk;
    WebPageControl1Sheet2.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet2.Name := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.Left := 0;
    WebPageControl1Sheet2.Top := 20;
    WebPageControl1Sheet2.Width := 729;
    WebPageControl1Sheet2.Height := 421;
    WebPageControl1Sheet2.Caption := 'Kalkulacja Cash Flow ';
    WebGroupBox1.SetParentComponent(WebPageControl1Sheet2);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 3;
    WebGroupBox1.Top := 3;
    WebGroupBox1.Width := 723;
    WebGroupBox1.Height := 416;
    WebGroupBox1.ChildOrder := 27;
    WebGroupBox1.Color := clWhite;
    WebLabel7.SetParentComponent(WebGroupBox1);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 18;
    WebLabel7.Top := 29;
    WebLabel7.Width := 22;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Rok';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -11;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.ParentFont := False;
    WebLabel22.SetParentComponent(WebGroupBox1);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 18;
    WebLabel22.Top := 68;
    WebLabel22.Width := 175;
    WebLabel22.Height := 13;
    WebLabel22.Caption := 'Wynik firmy po opodatkowaniu';
    WebLabel22.Font.Charset := DEFAULT_CHARSET;
    WebLabel22.Font.Color := clWindowText;
    WebLabel22.Font.Height := -11;
    WebLabel22.Font.Name := 'Tahoma';
    WebLabel22.Font.Style := [fsBold];
    WebLabel22.ParentFont := False;
    WebLabel23.SetParentComponent(WebGroupBox1);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 18;
    WebLabel23.Top := 93;
    WebLabel23.Width := 91;
    WebLabel23.Height := 13;
    WebLabel23.Caption := 'Potencja'#322'y synergii';
    WebLabel23.Font.Charset := DEFAULT_CHARSET;
    WebLabel23.Font.Color := clWindowText;
    WebLabel23.Font.Height := -11;
    WebLabel23.Font.Name := 'Tahoma';
    WebLabel23.Font.Style := [];
    WebLabel23.ParentFont := False;
    WebLabel24.SetParentComponent(WebGroupBox1);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 18;
    WebLabel24.Top := 118;
    WebLabel24.Width := 134;
    WebLabel24.Height := 13;
    WebLabel24.Caption := 'Inne potencjalne przychody';
    WebLabel24.Font.Charset := DEFAULT_CHARSET;
    WebLabel24.Font.Color := clWindowText;
    WebLabel24.Font.Height := -11;
    WebLabel24.Font.Name := 'Tahoma';
    WebLabel24.Font.Style := [];
    WebLabel24.ParentFont := False;
    WebLabel25.SetParentComponent(WebGroupBox1);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 18;
    WebLabel25.Top := 143;
    WebLabel25.Width := 110;
    WebLabel25.Height := 13;
    WebLabel25.Caption := 'Koszty restrukturyzacji';
    WebLabel25.Font.Charset := DEFAULT_CHARSET;
    WebLabel25.Font.Color := clWindowText;
    WebLabel25.Font.Height := -11;
    WebLabel25.Font.Name := 'Tahoma';
    WebLabel25.Font.Style := [];
    WebLabel25.ParentFont := False;
    WebLabel26.SetParentComponent(WebGroupBox1);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 18;
    WebLabel26.Top := 168;
    WebLabel26.Width := 36;
    WebLabel26.Height := 13;
    WebLabel26.Caption := 'Odsetki';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clWindowText;
    WebLabel26.Font.Height := -11;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [];
    WebLabel26.ParentFont := False;
    WebLabel27.SetParentComponent(WebGroupBox1);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 18;
    WebLabel27.Top := 207;
    WebLabel27.Width := 178;
    WebLabel27.Height := 13;
    WebLabel27.Caption := 'Wnykik przed opodatkowaniem';
    WebLabel27.Font.Charset := DEFAULT_CHARSET;
    WebLabel27.Font.Color := clWindowText;
    WebLabel27.Font.Height := -11;
    WebLabel27.Font.Name := 'Tahoma';
    WebLabel27.Font.Style := [fsBold];
    WebLabel27.ParentFont := False;
    WebLabel28.SetParentComponent(WebGroupBox1);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 18;
    WebLabel28.Top := 247;
    WebLabel28.Width := 60;
    WebLabel28.Height := 13;
    WebLabel28.Caption := 'Amortyzacja';
    WebLabel28.Font.Charset := DEFAULT_CHARSET;
    WebLabel28.Font.Color := clWindowText;
    WebLabel28.Font.Height := -11;
    WebLabel28.Font.Name := 'Tahoma';
    WebLabel28.Font.Style := [];
    WebLabel28.ParentFont := False;
    WebLabel29.SetParentComponent(WebGroupBox1);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 17;
    WebLabel29.Top := 272;
    WebLabel29.Width := 47;
    WebLabel29.Height := 13;
    WebLabel29.Caption := 'Iwestycje';
    WebLabel29.Font.Charset := DEFAULT_CHARSET;
    WebLabel29.Font.Color := clWindowText;
    WebLabel29.Font.Height := -11;
    WebLabel29.Font.Name := 'Tahoma';
    WebLabel29.Font.Style := [];
    WebLabel29.ParentFont := False;
    WebLabel30.SetParentComponent(WebGroupBox1);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 17;
    WebLabel30.Top := 297;
    WebLabel30.Width := 137;
    WebLabel30.Height := 13;
    WebLabel30.Caption := 'Zmiana '#347'rodk'#243'w obrotowych';
    WebLabel30.Font.Charset := DEFAULT_CHARSET;
    WebLabel30.Font.Color := clWindowText;
    WebLabel30.Font.Height := -11;
    WebLabel30.Font.Name := 'Tahoma';
    WebLabel30.Font.Style := [];
    WebLabel30.ParentFont := False;
    WebLabel31.SetParentComponent(WebGroupBox1);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 17;
    WebLabel31.Top := 334;
    WebLabel31.Width := 58;
    WebLabel31.Height := 13;
    WebLabel31.Caption := 'Cash Flow ';
    WebLabel31.Font.Charset := DEFAULT_CHARSET;
    WebLabel31.Font.Color := clBlue;
    WebLabel31.Font.Height := -11;
    WebLabel31.Font.Name := 'Tahoma';
    WebLabel31.Font.Style := [fsBold];
    WebLabel31.ParentFont := False;
    WebLabel94.SetParentComponent(WebGroupBox1);
    WebLabel94.Name := 'WebLabel94';
    WebLabel94.Left := 95;
    WebLabel94.Top := 391;
    WebLabel94.Width := 99;
    WebLabel94.Height := 10;
    WebLabel94.Caption := '- prosz'#281' wype'#322'ni'#263' '#380#243#322'te pola';
    WebLabel94.Font.Charset := DEFAULT_CHARSET;
    WebLabel94.Font.Color := clWindowText;
    WebLabel94.Font.Height := -8;
    WebLabel94.Font.Name := 'Tahoma';
    WebLabel94.Font.Style := [];
    WebLabel94.ParentFont := False;
    WebEdit7.SetParentComponent(WebGroupBox1);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 346;
    WebEdit7.Top := 65;
    WebEdit7.Width := 61;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 1;
    WebEdit7.Color := 12903679;
    WebEdit7.Enabled := False;
    WebEdit7.Text := '300000';
    WebEdit8.SetParentComponent(WebGroupBox1);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 346;
    WebEdit8.Top := 90;
    WebEdit8.Width := 61;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 2;
    WebEdit8.Color := clInfoBk;
    WebEdit8.Text := '0';
    WebEdit9.SetParentComponent(WebGroupBox1);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 346;
    WebEdit9.Top := 115;
    WebEdit9.Width := 61;
    WebEdit9.Height := 19;
    WebEdit9.ChildOrder := 3;
    WebEdit9.Color := clInfoBk;
    WebEdit9.Text := '0';
    WebEdit11.SetParentComponent(WebGroupBox1);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 346;
    WebEdit11.Top := 140;
    WebEdit11.Width := 61;
    WebEdit11.Height := 19;
    WebEdit11.ChildOrder := 4;
    WebEdit11.Color := clInfoBk;
    WebEdit11.Text := '20000';
    WebEdit12.SetParentComponent(WebGroupBox1);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 346;
    WebEdit12.Top := 165;
    WebEdit12.Width := 61;
    WebEdit12.Height := 19;
    WebEdit12.ChildOrder := 5;
    WebEdit12.Color := clInfoBk;
    WebEdit12.Text := '50000';
    WebEdit13.SetParentComponent(WebGroupBox1);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 346;
    WebEdit13.Top := 204;
    WebEdit13.Width := 61;
    WebEdit13.Height := 19;
    WebEdit13.ChildOrder := 6;
    WebEdit13.Color := 12903679;
    WebEdit13.Text := '330000';
    WebEdit14.SetParentComponent(WebGroupBox1);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 346;
    WebEdit14.Top := 244;
    WebEdit14.Width := 61;
    WebEdit14.Height := 19;
    WebEdit14.ChildOrder := 7;
    WebEdit14.Color := 12903679;
    WebEdit14.Enabled := False;
    WebEdit14.Text := '100000';
    WebEdit15.SetParentComponent(WebGroupBox1);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 346;
    WebEdit15.Top := 26;
    WebEdit15.Width := 61;
    WebEdit15.Height := 19;
    WebEdit15.ChildOrder := 8;
    WebEdit15.Color := 12903679;
    WebEdit15.Enabled := False;
    WebEdit15.Text := '2020';
    WebEdit19.SetParentComponent(WebGroupBox1);
    WebEdit19.Name := 'WebEdit19';
    WebEdit19.Left := 345;
    WebEdit19.Top := 269;
    WebEdit19.Width := 61;
    WebEdit19.Height := 19;
    WebEdit19.ChildOrder := 7;
    WebEdit19.Color := clInfoBk;
    WebEdit19.Text := '0';
    WebEdit20.SetParentComponent(WebGroupBox1);
    WebEdit20.Name := 'WebEdit20';
    WebEdit20.Left := 345;
    WebEdit20.Top := 294;
    WebEdit20.Width := 61;
    WebEdit20.Height := 19;
    WebEdit20.ChildOrder := 7;
    WebEdit20.Color := clInfoBk;
    WebEdit20.Text := '0';
    WebEdit21.SetParentComponent(WebGroupBox1);
    WebEdit21.Name := 'WebEdit21';
    WebEdit21.Left := 345;
    WebEdit21.Top := 331;
    WebEdit21.Width := 61;
    WebEdit21.Height := 19;
    WebEdit21.ChildOrder := 7;
    WebEdit21.Color := 12903679;
    WebEdit21.Enabled := False;
    WebEdit21.Text := '430000';
    WebEdit22.SetParentComponent(WebGroupBox1);
    WebEdit22.Name := 'WebEdit22';
    WebEdit22.Left := 416;
    WebEdit22.Top := 26;
    WebEdit22.Width := 61;
    WebEdit22.Height := 19;
    WebEdit22.ChildOrder := 8;
    WebEdit22.Color := 12903679;
    WebEdit22.Enabled := False;
    WebEdit22.Text := '2021';
    WebEdit23.SetParentComponent(WebGroupBox1);
    WebEdit23.Name := 'WebEdit23';
    WebEdit23.Left := 416;
    WebEdit23.Top := 65;
    WebEdit23.Width := 61;
    WebEdit23.Height := 19;
    WebEdit23.ChildOrder := 1;
    WebEdit23.Color := clInfoBk;
    WebEdit23.Text := '320000';
    WebEdit24.SetParentComponent(WebGroupBox1);
    WebEdit24.Name := 'WebEdit24';
    WebEdit24.Left := 416;
    WebEdit24.Top := 90;
    WebEdit24.Width := 61;
    WebEdit24.Height := 19;
    WebEdit24.ChildOrder := 2;
    WebEdit24.Color := clInfoBk;
    WebEdit24.Text := '0';
    WebEdit25.SetParentComponent(WebGroupBox1);
    WebEdit25.Name := 'WebEdit25';
    WebEdit25.Left := 416;
    WebEdit25.Top := 115;
    WebEdit25.Width := 61;
    WebEdit25.Height := 19;
    WebEdit25.ChildOrder := 3;
    WebEdit25.Color := clInfoBk;
    WebEdit25.Text := '0';
    WebEdit26.SetParentComponent(WebGroupBox1);
    WebEdit26.Name := 'WebEdit26';
    WebEdit26.Left := 416;
    WebEdit26.Top := 140;
    WebEdit26.Width := 61;
    WebEdit26.Height := 19;
    WebEdit26.ChildOrder := 4;
    WebEdit26.Color := clInfoBk;
    WebEdit26.Text := '20000';
    WebEdit27.SetParentComponent(WebGroupBox1);
    WebEdit27.Name := 'WebEdit27';
    WebEdit27.Left := 416;
    WebEdit27.Top := 165;
    WebEdit27.Width := 61;
    WebEdit27.Height := 19;
    WebEdit27.ChildOrder := 5;
    WebEdit27.Color := clInfoBk;
    WebEdit27.Text := '30000';
    WebEdit28.SetParentComponent(WebGroupBox1);
    WebEdit28.Name := 'WebEdit28';
    WebEdit28.Left := 416;
    WebEdit28.Top := 204;
    WebEdit28.Width := 61;
    WebEdit28.Height := 19;
    WebEdit28.ChildOrder := 6;
    WebEdit28.Color := 12903679;
    WebEdit28.Enabled := False;
    WebEdit28.Text := '330000';
    WebEdit29.SetParentComponent(WebGroupBox1);
    WebEdit29.Name := 'WebEdit29';
    WebEdit29.Left := 416;
    WebEdit29.Top := 244;
    WebEdit29.Width := 61;
    WebEdit29.Height := 19;
    WebEdit29.ChildOrder := 7;
    WebEdit29.Color := clInfoBk;
    WebEdit29.Text := '100000';
    WebEdit30.SetParentComponent(WebGroupBox1);
    WebEdit30.Name := 'WebEdit30';
    WebEdit30.Left := 415;
    WebEdit30.Top := 269;
    WebEdit30.Width := 61;
    WebEdit30.Height := 19;
    WebEdit30.ChildOrder := 7;
    WebEdit30.Color := clInfoBk;
    WebEdit30.Text := '50000';
    WebEdit47.SetParentComponent(WebGroupBox1);
    WebEdit47.Name := 'WebEdit47';
    WebEdit47.Left := 415;
    WebEdit47.Top := 294;
    WebEdit47.Width := 61;
    WebEdit47.Height := 19;
    WebEdit47.ChildOrder := 7;
    WebEdit47.Color := clInfoBk;
    WebEdit47.Text := '-10000';
    WebEdit48.SetParentComponent(WebGroupBox1);
    WebEdit48.Name := 'WebEdit48';
    WebEdit48.Left := 415;
    WebEdit48.Top := 331;
    WebEdit48.Width := 61;
    WebEdit48.Height := 19;
    WebEdit48.ChildOrder := 7;
    WebEdit48.Color := 12903679;
    WebEdit48.Enabled := False;
    WebEdit48.Text := '370000';
    WebEdit49.SetParentComponent(WebGroupBox1);
    WebEdit49.Name := 'WebEdit49';
    WebEdit49.Left := 486;
    WebEdit49.Top := 26;
    WebEdit49.Width := 61;
    WebEdit49.Height := 19;
    WebEdit49.ChildOrder := 8;
    WebEdit49.Color := 12903679;
    WebEdit49.Enabled := False;
    WebEdit49.Text := '2022';
    WebEdit50.SetParentComponent(WebGroupBox1);
    WebEdit50.Name := 'WebEdit50';
    WebEdit50.Left := 486;
    WebEdit50.Top := 65;
    WebEdit50.Width := 61;
    WebEdit50.Height := 19;
    WebEdit50.ChildOrder := 1;
    WebEdit50.Color := clInfoBk;
    WebEdit50.Text := '330000';
    WebEdit51.SetParentComponent(WebGroupBox1);
    WebEdit51.Name := 'WebEdit51';
    WebEdit51.Left := 486;
    WebEdit51.Top := 90;
    WebEdit51.Width := 61;
    WebEdit51.Height := 19;
    WebEdit51.ChildOrder := 2;
    WebEdit51.Color := clInfoBk;
    WebEdit51.Text := '0';
    WebEdit52.SetParentComponent(WebGroupBox1);
    WebEdit52.Name := 'WebEdit52';
    WebEdit52.Left := 486;
    WebEdit52.Top := 115;
    WebEdit52.Width := 61;
    WebEdit52.Height := 19;
    WebEdit52.ChildOrder := 3;
    WebEdit52.Color := clInfoBk;
    WebEdit52.Text := '0';
    WebEdit53.SetParentComponent(WebGroupBox1);
    WebEdit53.Name := 'WebEdit53';
    WebEdit53.Left := 486;
    WebEdit53.Top := 140;
    WebEdit53.Width := 61;
    WebEdit53.Height := 19;
    WebEdit53.ChildOrder := 4;
    WebEdit53.Color := clInfoBk;
    WebEdit53.Text := '10000';
    WebEdit54.SetParentComponent(WebGroupBox1);
    WebEdit54.Name := 'WebEdit54';
    WebEdit54.Left := 486;
    WebEdit54.Top := 165;
    WebEdit54.Width := 61;
    WebEdit54.Height := 19;
    WebEdit54.ChildOrder := 5;
    WebEdit54.Color := clInfoBk;
    WebEdit54.Text := '20000';
    WebEdit55.SetParentComponent(WebGroupBox1);
    WebEdit55.Name := 'WebEdit55';
    WebEdit55.Left := 486;
    WebEdit55.Top := 204;
    WebEdit55.Width := 61;
    WebEdit55.Height := 19;
    WebEdit55.ChildOrder := 6;
    WebEdit55.Color := 12903679;
    WebEdit55.Enabled := False;
    WebEdit55.Text := '340000';
    WebEdit56.SetParentComponent(WebGroupBox1);
    WebEdit56.Name := 'WebEdit56';
    WebEdit56.Left := 486;
    WebEdit56.Top := 244;
    WebEdit56.Width := 61;
    WebEdit56.Height := 19;
    WebEdit56.ChildOrder := 7;
    WebEdit56.Color := clInfoBk;
    WebEdit56.Text := '80000';
    WebEdit57.SetParentComponent(WebGroupBox1);
    WebEdit57.Name := 'WebEdit57';
    WebEdit57.Left := 485;
    WebEdit57.Top := 269;
    WebEdit57.Width := 61;
    WebEdit57.Height := 19;
    WebEdit57.ChildOrder := 7;
    WebEdit57.Color := clInfoBk;
    WebEdit57.Text := '0';
    WebEdit58.SetParentComponent(WebGroupBox1);
    WebEdit58.Name := 'WebEdit58';
    WebEdit58.Left := 485;
    WebEdit58.Top := 294;
    WebEdit58.Width := 61;
    WebEdit58.Height := 19;
    WebEdit58.ChildOrder := 7;
    WebEdit58.Color := clInfoBk;
    WebEdit58.Text := '-10000';
    WebEdit59.SetParentComponent(WebGroupBox1);
    WebEdit59.Name := 'WebEdit59';
    WebEdit59.Left := 485;
    WebEdit59.Top := 331;
    WebEdit59.Width := 61;
    WebEdit59.Height := 19;
    WebEdit59.ChildOrder := 7;
    WebEdit59.Color := 12903679;
    WebEdit59.Enabled := False;
    WebEdit59.Text := '410000';
    WebEdit60.SetParentComponent(WebGroupBox1);
    WebEdit60.Name := 'WebEdit60';
    WebEdit60.Left := 556;
    WebEdit60.Top := 26;
    WebEdit60.Width := 61;
    WebEdit60.Height := 19;
    WebEdit60.ChildOrder := 8;
    WebEdit60.Color := 12903679;
    WebEdit60.Enabled := False;
    WebEdit60.Text := '2023';
    WebEdit61.SetParentComponent(WebGroupBox1);
    WebEdit61.Name := 'WebEdit61';
    WebEdit61.Left := 556;
    WebEdit61.Top := 65;
    WebEdit61.Width := 61;
    WebEdit61.Height := 19;
    WebEdit61.ChildOrder := 1;
    WebEdit61.Color := clInfoBk;
    WebEdit61.Text := '330000';
    WebEdit62.SetParentComponent(WebGroupBox1);
    WebEdit62.Name := 'WebEdit62';
    WebEdit62.Left := 556;
    WebEdit62.Top := 90;
    WebEdit62.Width := 61;
    WebEdit62.Height := 19;
    WebEdit62.ChildOrder := 2;
    WebEdit62.Color := clInfoBk;
    WebEdit62.Text := '0';
    WebEdit63.SetParentComponent(WebGroupBox1);
    WebEdit63.Name := 'WebEdit63';
    WebEdit63.Left := 556;
    WebEdit63.Top := 115;
    WebEdit63.Width := 61;
    WebEdit63.Height := 19;
    WebEdit63.ChildOrder := 3;
    WebEdit63.Color := clInfoBk;
    WebEdit63.Text := '0';
    WebEdit64.SetParentComponent(WebGroupBox1);
    WebEdit64.Name := 'WebEdit64';
    WebEdit64.Left := 556;
    WebEdit64.Top := 140;
    WebEdit64.Width := 61;
    WebEdit64.Height := 19;
    WebEdit64.ChildOrder := 4;
    WebEdit64.Color := clInfoBk;
    WebEdit64.Text := '0';
    WebEdit65.SetParentComponent(WebGroupBox1);
    WebEdit65.Name := 'WebEdit65';
    WebEdit65.Left := 556;
    WebEdit65.Top := 165;
    WebEdit65.Width := 61;
    WebEdit65.Height := 19;
    WebEdit65.ChildOrder := 5;
    WebEdit65.Color := clInfoBk;
    WebEdit65.Text := '10000';
    WebEdit66.SetParentComponent(WebGroupBox1);
    WebEdit66.Name := 'WebEdit66';
    WebEdit66.Left := 556;
    WebEdit66.Top := 204;
    WebEdit66.Width := 61;
    WebEdit66.Height := 19;
    WebEdit66.ChildOrder := 6;
    WebEdit66.Color := 12903679;
    WebEdit66.Enabled := False;
    WebEdit66.Text := '340000';
    WebEdit67.SetParentComponent(WebGroupBox1);
    WebEdit67.Name := 'WebEdit67';
    WebEdit67.Left := 556;
    WebEdit67.Top := 244;
    WebEdit67.Width := 61;
    WebEdit67.Height := 19;
    WebEdit67.ChildOrder := 7;
    WebEdit67.Color := clInfoBk;
    WebEdit67.Text := '80000';
    WebEdit68.SetParentComponent(WebGroupBox1);
    WebEdit68.Name := 'WebEdit68';
    WebEdit68.Left := 555;
    WebEdit68.Top := 269;
    WebEdit68.Width := 61;
    WebEdit68.Height := 19;
    WebEdit68.ChildOrder := 7;
    WebEdit68.Color := clInfoBk;
    WebEdit68.Text := '50000';
    WebEdit69.SetParentComponent(WebGroupBox1);
    WebEdit69.Name := 'WebEdit69';
    WebEdit69.Left := 555;
    WebEdit69.Top := 294;
    WebEdit69.Width := 61;
    WebEdit69.Height := 19;
    WebEdit69.ChildOrder := 7;
    WebEdit69.Color := clInfoBk;
    WebEdit69.Text := '0';
    WebEdit70.SetParentComponent(WebGroupBox1);
    WebEdit70.Name := 'WebEdit70';
    WebEdit70.Left := 555;
    WebEdit70.Top := 331;
    WebEdit70.Width := 61;
    WebEdit70.Height := 19;
    WebEdit70.ChildOrder := 7;
    WebEdit70.Color := 12903679;
    WebEdit70.Enabled := False;
    WebEdit70.Text := '370000';
    WebEdit71.SetParentComponent(WebGroupBox1);
    WebEdit71.Name := 'WebEdit71';
    WebEdit71.Left := 626;
    WebEdit71.Top := 26;
    WebEdit71.Width := 61;
    WebEdit71.Height := 19;
    WebEdit71.ChildOrder := 8;
    WebEdit71.Color := 12903679;
    WebEdit71.Enabled := False;
    WebEdit71.Text := '2024';
    WebEdit72.SetParentComponent(WebGroupBox1);
    WebEdit72.Name := 'WebEdit72';
    WebEdit72.Left := 626;
    WebEdit72.Top := 65;
    WebEdit72.Width := 61;
    WebEdit72.Height := 19;
    WebEdit72.ChildOrder := 1;
    WebEdit72.Color := clInfoBk;
    WebEdit72.Text := '280000';
    WebEdit73.SetParentComponent(WebGroupBox1);
    WebEdit73.Name := 'WebEdit73';
    WebEdit73.Left := 626;
    WebEdit73.Top := 90;
    WebEdit73.Width := 61;
    WebEdit73.Height := 19;
    WebEdit73.ChildOrder := 2;
    WebEdit73.Color := clInfoBk;
    WebEdit73.Text := '0';
    WebEdit74.SetParentComponent(WebGroupBox1);
    WebEdit74.Name := 'WebEdit74';
    WebEdit74.Left := 626;
    WebEdit74.Top := 115;
    WebEdit74.Width := 61;
    WebEdit74.Height := 19;
    WebEdit74.ChildOrder := 3;
    WebEdit74.Color := clInfoBk;
    WebEdit74.Text := '0';
    WebEdit75.SetParentComponent(WebGroupBox1);
    WebEdit75.Name := 'WebEdit75';
    WebEdit75.Left := 626;
    WebEdit75.Top := 140;
    WebEdit75.Width := 61;
    WebEdit75.Height := 19;
    WebEdit75.ChildOrder := 4;
    WebEdit75.Color := clInfoBk;
    WebEdit75.Text := '0';
    WebEdit76.SetParentComponent(WebGroupBox1);
    WebEdit76.Name := 'WebEdit76';
    WebEdit76.Left := 626;
    WebEdit76.Top := 165;
    WebEdit76.Width := 61;
    WebEdit76.Height := 19;
    WebEdit76.ChildOrder := 5;
    WebEdit76.Color := clInfoBk;
    WebEdit76.Text := '10000';
    WebEdit77.SetParentComponent(WebGroupBox1);
    WebEdit77.Name := 'WebEdit77';
    WebEdit77.Left := 626;
    WebEdit77.Top := 204;
    WebEdit77.Width := 61;
    WebEdit77.Height := 19;
    WebEdit77.ChildOrder := 6;
    WebEdit77.Color := 12903679;
    WebEdit77.Enabled := False;
    WebEdit77.Text := '290000';
    WebEdit78.SetParentComponent(WebGroupBox1);
    WebEdit78.Name := 'WebEdit78';
    WebEdit78.Left := 626;
    WebEdit78.Top := 244;
    WebEdit78.Width := 61;
    WebEdit78.Height := 19;
    WebEdit78.ChildOrder := 7;
    WebEdit78.Color := clInfoBk;
    WebEdit78.Text := '60000';
    WebEdit79.SetParentComponent(WebGroupBox1);
    WebEdit79.Name := 'WebEdit79';
    WebEdit79.Left := 625;
    WebEdit79.Top := 269;
    WebEdit79.Width := 61;
    WebEdit79.Height := 19;
    WebEdit79.ChildOrder := 7;
    WebEdit79.Color := clInfoBk;
    WebEdit79.Text := '0';
    WebEdit80.SetParentComponent(WebGroupBox1);
    WebEdit80.Name := 'WebEdit80';
    WebEdit80.Left := 625;
    WebEdit80.Top := 294;
    WebEdit80.Width := 61;
    WebEdit80.Height := 19;
    WebEdit80.ChildOrder := 7;
    WebEdit80.Color := clInfoBk;
    WebEdit80.Text := '20000';
    WebEdit81.SetParentComponent(WebGroupBox1);
    WebEdit81.Name := 'WebEdit81';
    WebEdit81.Left := 625;
    WebEdit81.Top := 331;
    WebEdit81.Width := 61;
    WebEdit81.Height := 19;
    WebEdit81.ChildOrder := 7;
    WebEdit81.Color := 12903679;
    WebEdit81.Enabled := False;
    WebEdit81.Text := '370000';
    WebBitBtn2.SetParentComponent(WebGroupBox1);
    WebBitBtn2.Name := 'WebBitBtn2';
    WebBitBtn2.Left := 576;
    WebBitBtn2.Top := 367;
    WebBitBtn2.Width := 129;
    WebBitBtn2.Height := 37;
    WebBitBtn2.Caption := 'Odsetki >>';
    WebBitBtn2.Color := clBtnFace;
    WebBitBtn2.Glyph.LoadFromFile('Factor.WebGroupBox1.WebBitBtn2.Glyph.bmp');
    WebBitBtn2.TabOrder := 55;
    SetEvent(WebBitBtn2, Self, 'OnClick', 'WebBitBtn2Click');
    WebEdit115.SetParentComponent(WebGroupBox1);
    WebEdit115.Name := 'WebEdit115';
    WebEdit115.Left := 33;
    WebEdit115.Top := 387;
    WebEdit115.Width := 48;
    WebEdit115.Height := 19;
    WebEdit115.ChildOrder := 36;
    WebEdit115.Color := clInfoBk;
    WebPageControl1Sheet3.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet3.Name := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.Left := 0;
    WebPageControl1Sheet3.Top := 20;
    WebPageControl1Sheet3.Width := 729;
    WebPageControl1Sheet3.Height := 421;
    WebPageControl1Sheet3.Caption := 'Kalkulacja odsetek ';
    WebGroupBox4.SetParentComponent(WebPageControl1Sheet3);
    WebGroupBox4.Name := 'WebGroupBox4';
    WebGroupBox4.Left := 3;
    WebGroupBox4.Top := 2;
    WebGroupBox4.Width := 723;
    WebGroupBox4.Height := 416;
    WebGroupBox4.ChildOrder := 27;
    WebGroupBox4.Color := clWhite;
    WebLabel66.SetParentComponent(WebGroupBox4);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 18;
    WebLabel66.Top := 26;
    WebLabel66.Width := 109;
    WebLabel66.Height := 13;
    WebLabel66.Caption := 'Odsetki kapita'#322'owe';
    WebLabel66.Font.Charset := DEFAULT_CHARSET;
    WebLabel66.Font.Color := clWindowText;
    WebLabel66.Font.Height := -11;
    WebLabel66.Font.Name := 'Tahoma';
    WebLabel66.Font.Style := [fsBold];
    WebLabel66.ParentFont := False;
    WebLabel68.SetParentComponent(WebGroupBox4);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 18;
    WebLabel68.Top := 49;
    WebLabel68.Width := 112;
    WebLabel68.Height := 13;
    WebLabel68.Caption := 'Pewne oprocentowanie';
    WebLabel68.Font.Charset := DEFAULT_CHARSET;
    WebLabel68.Font.Color := clWindowText;
    WebLabel68.Font.Height := -11;
    WebLabel68.Font.Name := 'Tahoma';
    WebLabel68.Font.Style := [];
    WebLabel68.ParentFont := False;
    WebLabel71.SetParentComponent(WebGroupBox4);
    WebLabel71.Name := 'WebLabel71';
    WebLabel71.Left := 18;
    WebLabel71.Top := 72;
    WebLabel71.Width := 140;
    WebLabel71.Height := 13;
    WebLabel71.Caption := '+ premia za ryzyko /wa'#380'ona/';
    WebLabel71.Font.Charset := DEFAULT_CHARSET;
    WebLabel71.Font.Color := clWindowText;
    WebLabel71.Font.Height := -11;
    WebLabel71.Font.Name := 'Tahoma';
    WebLabel71.Font.Style := [];
    WebLabel71.ParentFont := False;
    WebLabel75.SetParentComponent(WebGroupBox4);
    WebLabel75.Name := 'WebLabel75';
    WebLabel75.Left := 18;
    WebLabel75.Top := 95;
    WebLabel75.Width := 199;
    WebLabel75.Height := 13;
    WebLabel75.Caption := 'Oprocentowanie kapita'#322'u w'#322'asnego';
    WebLabel75.Font.Charset := DEFAULT_CHARSET;
    WebLabel75.Font.Color := clWindowText;
    WebLabel75.Font.Height := -11;
    WebLabel75.Font.Name := 'Tahoma';
    WebLabel75.Font.Style := [fsBold];
    WebLabel75.ParentFont := False;
    WebLabel77.SetParentComponent(WebGroupBox4);
    WebLabel77.Name := 'WebLabel77';
    WebLabel77.Left := 18;
    WebLabel77.Top := 118;
    WebLabel77.Width := 148;
    WebLabel77.Height := 13;
    WebLabel77.Caption := 'Oprocentowanie akcji na rynku';
    WebLabel77.Font.Charset := DEFAULT_CHARSET;
    WebLabel77.Font.Color := clWindowText;
    WebLabel77.Font.Height := -11;
    WebLabel77.Font.Name := 'Tahoma';
    WebLabel77.Font.Style := [];
    WebLabel77.ParentFont := False;
    WebLabel79.SetParentComponent(WebGroupBox4);
    WebLabel79.Name := 'WebLabel79';
    WebLabel79.Left := 18;
    WebLabel79.Top := 141;
    WebLabel79.Width := 119;
    WebLabel79.Height := 13;
    WebLabel79.Caption := '/ pewne oprocentowanie';
    WebLabel79.Font.Charset := DEFAULT_CHARSET;
    WebLabel79.Font.Color := clWindowText;
    WebLabel79.Font.Height := -11;
    WebLabel79.Font.Name := 'Tahoma';
    WebLabel79.Font.Style := [];
    WebLabel79.ParentFont := False;
    WebLabel80.SetParentComponent(WebGroupBox4);
    WebLabel80.Name := 'WebLabel80';
    WebLabel80.Left := 18;
    WebLabel80.Top := 164;
    WebLabel80.Width := 98;
    WebLabel80.Height := 13;
    WebLabel80.Caption := 'Premia za ryzyko';
    WebLabel80.Font.Charset := DEFAULT_CHARSET;
    WebLabel80.Font.Color := clWindowText;
    WebLabel80.Font.Height := -11;
    WebLabel80.Font.Name := 'Tahoma';
    WebLabel80.Font.Style := [fsBold];
    WebLabel80.ParentFont := False;
    WebLabel85.SetParentComponent(WebGroupBox4);
    WebLabel85.Name := 'WebLabel85';
    WebLabel85.Left := 18;
    WebLabel85.Top := 187;
    WebLabel85.Width := 156;
    WebLabel85.Height := 13;
    WebLabel85.Caption := 'Premia za ryzyko /wa'#380'ona/';
    WebLabel85.Font.Charset := DEFAULT_CHARSET;
    WebLabel85.Font.Color := clWindowText;
    WebLabel85.Font.Height := -11;
    WebLabel85.Font.Name := 'Tahoma';
    WebLabel85.Font.Style := [fsBold];
    WebLabel85.ParentFont := False;
    WebLabel87.SetParentComponent(WebGroupBox4);
    WebLabel87.Name := 'WebLabel87';
    WebLabel87.Left := 17;
    WebLabel87.Top := 210;
    WebLabel87.Width := 116;
    WebLabel87.Height := 13;
    WebLabel87.Caption := 'Okre'#347'lenie ryzyka premii';
    WebLabel87.Font.Charset := DEFAULT_CHARSET;
    WebLabel87.Font.Color := clWindowText;
    WebLabel87.Font.Height := -11;
    WebLabel87.Font.Name := 'Tahoma';
    WebLabel87.Font.Style := [];
    WebLabel87.ParentFont := False;
    WebLabel89.SetParentComponent(WebGroupBox4);
    WebLabel89.Name := 'WebLabel89';
    WebLabel89.Left := 17;
    WebLabel89.Top := 233;
    WebLabel89.Width := 118;
    WebLabel89.Height := 13;
    WebLabel89.Caption := 'Udzia'#322' premii kapita'#322'owej';
    WebLabel89.Font.Charset := DEFAULT_CHARSET;
    WebLabel89.Font.Color := clWindowText;
    WebLabel89.Font.Height := -11;
    WebLabel89.Font.Name := 'Tahoma';
    WebLabel89.Font.Style := [];
    WebLabel89.ParentFont := False;
    WebLabel91.SetParentComponent(WebGroupBox4);
    WebLabel91.Name := 'WebLabel91';
    WebLabel91.Left := 17;
    WebLabel91.Top := 255;
    WebLabel91.Width := 119;
    WebLabel91.Height := 13;
    WebLabel91.Caption := 'Udzia'#322' kapita'#322'u w'#322'asnego';
    WebLabel91.Font.Charset := DEFAULT_CHARSET;
    WebLabel91.Font.Color := clWindowText;
    WebLabel91.Font.Height := -11;
    WebLabel91.Font.Name := 'Tahoma';
    WebLabel91.Font.Style := [];
    WebLabel91.ParentFont := False;
    WebLabel2.SetParentComponent(WebGroupBox4);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 17;
    WebLabel2.Top := 278;
    WebLabel2.Width := 82;
    WebLabel2.Height := 13;
    WebLabel2.Caption := #321#261'czny kapita'#322;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -11;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.ParentFont := False;
    WebLabel3.SetParentComponent(WebGroupBox4);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 17;
    WebLabel3.Top := 301;
    WebLabel3.Width := 71;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Obcy kapita'#322;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -11;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.ParentFont := False;
    WebLabel4.SetParentComponent(WebGroupBox4);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 18;
    WebLabel4.Top := 324;
    WebLabel4.Width := 85;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'W'#322'asny kapita'#322;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.ParentFont := False;
    WebLabel5.SetParentComponent(WebGroupBox4);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 17;
    WebLabel5.Top := 347;
    WebLabel5.Width := 99;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Obliczone odsetki';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clBlue;
    WebLabel5.Font.Height := -11;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.ParentFont := False;
    WebLabel6.SetParentComponent(WebGroupBox4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 359;
    WebLabel6.Top := 26;
    WebLabel6.Width := 11;
    WebLabel6.Height := 13;
    WebLabel6.Caption := '%';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -11;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.ParentFont := False;
    WebLabel8.SetParentComponent(WebGroupBox4);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 359;
    WebLabel8.Top := 49;
    WebLabel8.Width := 11;
    WebLabel8.Height := 13;
    WebLabel8.Caption := '%';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -11;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.ParentFont := False;
    WebLabel9.SetParentComponent(WebGroupBox4);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 359;
    WebLabel9.Top := 72;
    WebLabel9.Width := 11;
    WebLabel9.Height := 13;
    WebLabel9.Caption := '%';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -11;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.ParentFont := False;
    WebLabel10.SetParentComponent(WebGroupBox4);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 359;
    WebLabel10.Top := 95;
    WebLabel10.Width := 11;
    WebLabel10.Height := 13;
    WebLabel10.Caption := '%';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -11;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.ParentFont := False;
    WebLabel11.SetParentComponent(WebGroupBox4);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 359;
    WebLabel11.Top := 118;
    WebLabel11.Width := 11;
    WebLabel11.Height := 13;
    WebLabel11.Caption := '%';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -11;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [];
    WebLabel11.ParentFont := False;
    WebLabel12.SetParentComponent(WebGroupBox4);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 359;
    WebLabel12.Top := 141;
    WebLabel12.Width := 11;
    WebLabel12.Height := 13;
    WebLabel12.Caption := '%';
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -11;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [];
    WebLabel12.ParentFont := False;
    WebLabel13.SetParentComponent(WebGroupBox4);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 359;
    WebLabel13.Top := 164;
    WebLabel13.Width := 11;
    WebLabel13.Height := 13;
    WebLabel13.Caption := '%';
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -11;
    WebLabel13.Font.Name := 'Tahoma';
    WebLabel13.Font.Style := [];
    WebLabel13.ParentFont := False;
    WebLabel14.SetParentComponent(WebGroupBox4);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 359;
    WebLabel14.Top := 187;
    WebLabel14.Width := 11;
    WebLabel14.Height := 13;
    WebLabel14.Caption := '%';
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -11;
    WebLabel14.Font.Name := 'Tahoma';
    WebLabel14.Font.Style := [];
    WebLabel14.ParentFont := False;
    WebLabel15.SetParentComponent(WebGroupBox4);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 359;
    WebLabel15.Top := 210;
    WebLabel15.Width := 11;
    WebLabel15.Height := 13;
    WebLabel15.Caption := '%';
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -11;
    WebLabel15.Font.Name := 'Tahoma';
    WebLabel15.Font.Style := [];
    WebLabel15.ParentFont := False;
    WebLabel16.SetParentComponent(WebGroupBox4);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 359;
    WebLabel16.Top := 233;
    WebLabel16.Width := 11;
    WebLabel16.Height := 13;
    WebLabel16.Caption := '%';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -11;
    WebLabel16.Font.Name := 'Tahoma';
    WebLabel16.Font.Style := [];
    WebLabel16.ParentFont := False;
    WebLabel17.SetParentComponent(WebGroupBox4);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 359;
    WebLabel17.Top := 255;
    WebLabel17.Width := 11;
    WebLabel17.Height := 13;
    WebLabel17.Caption := '%';
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -11;
    WebLabel17.Font.Name := 'Tahoma';
    WebLabel17.Font.Style := [];
    WebLabel17.ParentFont := False;
    WebLabel18.SetParentComponent(WebGroupBox4);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 359;
    WebLabel18.Top := 278;
    WebLabel18.Width := 11;
    WebLabel18.Height := 13;
    WebLabel18.Caption := '%';
    WebLabel18.Font.Charset := DEFAULT_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -11;
    WebLabel18.Font.Name := 'Tahoma';
    WebLabel18.Font.Style := [];
    WebLabel18.ParentFont := False;
    WebLabel19.SetParentComponent(WebGroupBox4);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 359;
    WebLabel19.Top := 301;
    WebLabel19.Width := 11;
    WebLabel19.Height := 13;
    WebLabel19.Caption := '%';
    WebLabel19.Font.Charset := DEFAULT_CHARSET;
    WebLabel19.Font.Color := clWindowText;
    WebLabel19.Font.Height := -11;
    WebLabel19.Font.Name := 'Tahoma';
    WebLabel19.Font.Style := [];
    WebLabel19.ParentFont := False;
    WebLabel20.SetParentComponent(WebGroupBox4);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 359;
    WebLabel20.Top := 324;
    WebLabel20.Width := 11;
    WebLabel20.Height := 13;
    WebLabel20.Caption := '%';
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -11;
    WebLabel20.Font.Name := 'Tahoma';
    WebLabel20.Font.Style := [];
    WebLabel20.ParentFont := False;
    WebLabel21.SetParentComponent(WebGroupBox4);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 359;
    WebLabel21.Top := 347;
    WebLabel21.Width := 11;
    WebLabel21.Height := 13;
    WebLabel21.Caption := '%';
    WebLabel21.Font.Charset := DEFAULT_CHARSET;
    WebLabel21.Font.Color := clWindowText;
    WebLabel21.Font.Height := -11;
    WebLabel21.Font.Name := 'Tahoma';
    WebLabel21.Font.Style := [];
    WebLabel21.ParentFont := False;
    WebLabel95.SetParentComponent(WebGroupBox4);
    WebLabel95.Name := 'WebLabel95';
    WebLabel95.Left := 95;
    WebLabel95.Top := 391;
    WebLabel95.Width := 99;
    WebLabel95.Height := 10;
    WebLabel95.Caption := '- prosz'#281' wype'#322'ni'#263' '#380#243#322'te pola';
    WebLabel95.Font.Charset := DEFAULT_CHARSET;
    WebLabel95.Font.Color := clWindowText;
    WebLabel95.Font.Height := -8;
    WebLabel95.Font.Name := 'Tahoma';
    WebLabel95.Font.Style := [];
    WebLabel95.ParentFont := False;
    WebImageControl4.SetParentComponent(WebGroupBox4);
    WebImageControl4.Name := 'WebImageControl4';
    WebImageControl4.Left := 461;
    WebImageControl4.Top := 24;
    WebImageControl4.Width := 244;
    WebImageControl4.Height := 324;
    WebImageControl4.ChildOrder := 38;
    WebImageControl4.Picture.LoadFromFile('Factor.WebGroupBox4.WebImageControl4.Picture.jpg');
    WebEdit36.SetParentComponent(WebGroupBox4);
    WebEdit36.Name := 'WebEdit36';
    WebEdit36.Left := 311;
    WebEdit36.Top := 46;
    WebEdit36.Width := 45;
    WebEdit36.Height := 19;
    WebEdit36.ChildOrder := 1;
    WebEdit36.Color := 12903679;
    WebEdit36.Enabled := False;
    WebEdit36.Text := '8,5';
    WebEdit37.SetParentComponent(WebGroupBox4);
    WebEdit37.Name := 'WebEdit37';
    WebEdit37.Left := 311;
    WebEdit37.Top := 69;
    WebEdit37.Width := 45;
    WebEdit37.Height := 19;
    WebEdit37.ChildOrder := 2;
    WebEdit37.Color := 12903679;
    WebEdit37.Enabled := False;
    WebEdit37.Text := '4,0';
    WebEdit38.SetParentComponent(WebGroupBox4);
    WebEdit38.Name := 'WebEdit38';
    WebEdit38.Left := 311;
    WebEdit38.Top := 92;
    WebEdit38.Width := 45;
    WebEdit38.Height := 19;
    WebEdit38.ChildOrder := 3;
    WebEdit38.Color := 12903679;
    WebEdit38.Enabled := False;
    WebEdit38.Text := '12,5';
    WebEdit39.SetParentComponent(WebGroupBox4);
    WebEdit39.Name := 'WebEdit39';
    WebEdit39.Left := 311;
    WebEdit39.Top := 115;
    WebEdit39.Width := 45;
    WebEdit39.Height := 19;
    WebEdit39.ChildOrder := 4;
    WebEdit39.Color := clInfoBk;
    WebEdit39.Text := '6,5';
    WebEdit40.SetParentComponent(WebGroupBox4);
    WebEdit40.Name := 'WebEdit40';
    WebEdit40.Left := 311;
    WebEdit40.Top := 138;
    WebEdit40.Width := 45;
    WebEdit40.Height := 19;
    WebEdit40.ChildOrder := 5;
    WebEdit40.Color := clInfoBk;
    WebEdit40.Text := '2,5';
    WebEdit41.SetParentComponent(WebGroupBox4);
    WebEdit41.Name := 'WebEdit41';
    WebEdit41.Left := 311;
    WebEdit41.Top := 161;
    WebEdit41.Width := 45;
    WebEdit41.Height := 19;
    WebEdit41.ChildOrder := 6;
    WebEdit41.Color := 12903679;
    WebEdit41.Text := '4';
    WebEdit42.SetParentComponent(WebGroupBox4);
    WebEdit42.Name := 'WebEdit42';
    WebEdit42.Left := 311;
    WebEdit42.Top := 184;
    WebEdit42.Width := 45;
    WebEdit42.Height := 19;
    WebEdit42.ChildOrder := 7;
    WebEdit42.Color := 12903679;
    WebEdit42.Enabled := False;
    WebEdit42.Text := '4';
    WebEdit43.SetParentComponent(WebGroupBox4);
    WebEdit43.Name := 'WebEdit43';
    WebEdit43.Left := 311;
    WebEdit43.Top := 23;
    WebEdit43.Width := 45;
    WebEdit43.Height := 19;
    WebEdit43.ChildOrder := 8;
    WebEdit43.Color := clInfoBk;
    WebEdit43.Text := '8,5';
    WebEdit44.SetParentComponent(WebGroupBox4);
    WebEdit44.Name := 'WebEdit44';
    WebEdit44.Left := 310;
    WebEdit44.Top := 207;
    WebEdit44.Width := 45;
    WebEdit44.Height := 19;
    WebEdit44.ChildOrder := 7;
    WebEdit44.Color := clInfoBk;
    WebEdit44.Text := '1';
    WebEdit45.SetParentComponent(WebGroupBox4);
    WebEdit45.Name := 'WebEdit45';
    WebEdit45.Left := 310;
    WebEdit45.Top := 230;
    WebEdit45.Width := 45;
    WebEdit45.Height := 19;
    WebEdit45.ChildOrder := 7;
    WebEdit45.Color := clInfoBk;
    WebEdit45.Text := '70';
    WebEdit46.SetParentComponent(WebGroupBox4);
    WebEdit46.Name := 'WebEdit46';
    WebEdit46.Left := 310;
    WebEdit46.Top := 252;
    WebEdit46.Width := 45;
    WebEdit46.Height := 19;
    WebEdit46.ChildOrder := 7;
    WebEdit46.Color := clInfoBk;
    WebEdit46.Text := '30';
    WebEdit2.SetParentComponent(WebGroupBox4);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 310;
    WebEdit2.Top := 275;
    WebEdit2.Width := 45;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 7;
    WebEdit2.Color := 12903679;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '100';
    WebEdit3.SetParentComponent(WebGroupBox4);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 310;
    WebEdit3.Top := 298;
    WebEdit3.Width := 45;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 7;
    WebEdit3.Color := 12903679;
    WebEdit3.Enabled := False;
    WebEdit3.Text := '5,95';
    WebEdit4.SetParentComponent(WebGroupBox4);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 311;
    WebEdit4.Top := 321;
    WebEdit4.Width := 45;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 7;
    WebEdit4.Color := 12903679;
    WebEdit4.Enabled := False;
    WebEdit4.Text := '3,75';
    WebEdit5.SetParentComponent(WebGroupBox4);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 310;
    WebEdit5.Top := 344;
    WebEdit5.Width := 45;
    WebEdit5.Height := 19;
    WebEdit5.ChildOrder := 7;
    WebEdit5.Color := 12903679;
    WebEdit5.Enabled := False;
    WebEdit5.Text := '9,7';
    WebBitBtn3.SetParentComponent(WebGroupBox4);
    WebBitBtn3.Name := 'WebBitBtn3';
    WebBitBtn3.Left := 576;
    WebBitBtn3.Top := 368;
    WebBitBtn3.Width := 129;
    WebBitBtn3.Height := 37;
    WebBitBtn3.Caption := 'Wycena >>';
    WebBitBtn3.Color := clBtnFace;
    WebBitBtn3.Glyph.LoadFromFile('Factor.WebGroupBox4.WebBitBtn3.Glyph.bmp');
    WebBitBtn3.TabOrder := 15;
    SetEvent(WebBitBtn3, Self, 'OnClick', 'WebBitBtn3Click');
    WebEdit118.SetParentComponent(WebGroupBox4);
    WebEdit118.Name := 'WebEdit118';
    WebEdit118.Left := 33;
    WebEdit118.Top := 387;
    WebEdit118.Width := 48;
    WebEdit118.Height := 19;
    WebEdit118.ChildOrder := 36;
    WebEdit118.Color := clInfoBk;
    WebPageControl1Sheet4.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet4.Name := 'WebPageControl1Sheet4';
    WebPageControl1Sheet4.Left := 0;
    WebPageControl1Sheet4.Top := 20;
    WebPageControl1Sheet4.Width := 729;
    WebPageControl1Sheet4.Height := 421;
    WebPageControl1Sheet4.Caption := 'Kalkulacja wyceny firmy ';
    WebGroupBox2.SetParentComponent(WebPageControl1Sheet4);
    WebGroupBox2.Name := 'WebGroupBox2';
    WebGroupBox2.Left := 3;
    WebGroupBox2.Top := 3;
    WebGroupBox2.Width := 723;
    WebGroupBox2.Height := 415;
    WebGroupBox2.ChildOrder := 27;
    WebGroupBox2.Color := clWhite;
    WebLabel32.SetParentComponent(WebGroupBox2);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 18;
    WebLabel32.Top := 22;
    WebLabel32.Width := 22;
    WebLabel32.Height := 13;
    WebLabel32.Caption := 'Rok';
    WebLabel32.Font.Charset := DEFAULT_CHARSET;
    WebLabel32.Font.Color := clWindowText;
    WebLabel32.Font.Height := -11;
    WebLabel32.Font.Name := 'Tahoma';
    WebLabel32.Font.Style := [fsBold];
    WebLabel32.ParentFont := False;
    WebLabel33.SetParentComponent(WebGroupBox2);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 18;
    WebLabel33.Top := 46;
    WebLabel33.Width := 53;
    WebLabel33.Height := 13;
    WebLabel33.Caption := 'Kolejny rok';
    WebLabel33.Font.Charset := DEFAULT_CHARSET;
    WebLabel33.Font.Color := clWindowText;
    WebLabel33.Font.Height := -11;
    WebLabel33.Font.Name := 'Tahoma';
    WebLabel33.Font.Style := [];
    WebLabel33.ParentFont := False;
    WebLabel34.SetParentComponent(WebGroupBox2);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 668;
    WebLabel34.Top := 98;
    WebLabel34.Width := 18;
    WebLabel34.Height := 13;
    WebLabel34.Caption := 'PLN';
    WebLabel34.Font.Charset := DEFAULT_CHARSET;
    WebLabel34.Font.Color := clWindowText;
    WebLabel34.Font.Height := -11;
    WebLabel34.Font.Name := 'Tahoma';
    WebLabel34.Font.Style := [];
    WebLabel34.ParentFont := False;
    WebLabel35.SetParentComponent(WebGroupBox2);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 668;
    WebLabel35.Top := 148;
    WebLabel35.Width := 18;
    WebLabel35.Height := 13;
    WebLabel35.Caption := 'PLN';
    WebLabel35.Font.Charset := DEFAULT_CHARSET;
    WebLabel35.Font.Color := clWindowText;
    WebLabel35.Font.Height := -11;
    WebLabel35.Font.Name := 'Tahoma';
    WebLabel35.Font.Style := [];
    WebLabel35.ParentFont := False;
    WebLabel36.SetParentComponent(WebGroupBox2);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 668;
    WebLabel36.Top := 173;
    WebLabel36.Width := 18;
    WebLabel36.Height := 13;
    WebLabel36.Caption := 'PLN';
    WebLabel36.Font.Charset := DEFAULT_CHARSET;
    WebLabel36.Font.Color := clWindowText;
    WebLabel36.Font.Height := -11;
    WebLabel36.Font.Name := 'Tahoma';
    WebLabel36.Font.Style := [];
    WebLabel36.ParentFont := False;
    WebLabel37.SetParentComponent(WebGroupBox2);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 668;
    WebLabel37.Top := 198;
    WebLabel37.Width := 18;
    WebLabel37.Height := 13;
    WebLabel37.Caption := 'PLN';
    WebLabel37.Font.Charset := DEFAULT_CHARSET;
    WebLabel37.Font.Color := clWindowText;
    WebLabel37.Font.Height := -11;
    WebLabel37.Font.Name := 'Tahoma';
    WebLabel37.Font.Style := [];
    WebLabel37.ParentFont := False;
    WebLabel38.SetParentComponent(WebGroupBox2);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 668;
    WebLabel38.Top := 223;
    WebLabel38.Width := 18;
    WebLabel38.Height := 13;
    WebLabel38.Caption := 'PLN';
    WebLabel38.Font.Charset := DEFAULT_CHARSET;
    WebLabel38.Font.Color := clWindowText;
    WebLabel38.Font.Height := -11;
    WebLabel38.Font.Name := 'Tahoma';
    WebLabel38.Font.Style := [];
    WebLabel38.ParentFont := False;
    WebLabel39.SetParentComponent(WebGroupBox2);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 668;
    WebLabel39.Top := 248;
    WebLabel39.Width := 18;
    WebLabel39.Height := 13;
    WebLabel39.Caption := 'PLN';
    WebLabel39.Font.Charset := DEFAULT_CHARSET;
    WebLabel39.Font.Color := clWindowText;
    WebLabel39.Font.Height := -11;
    WebLabel39.Font.Name := 'Tahoma';
    WebLabel39.Font.Style := [];
    WebLabel39.ParentFont := False;
    WebLabel40.SetParentComponent(WebGroupBox2);
    WebLabel40.Name := 'WebLabel40';
    WebLabel40.Left := 668;
    WebLabel40.Top := 273;
    WebLabel40.Width := 18;
    WebLabel40.Height := 13;
    WebLabel40.Caption := 'PLN';
    WebLabel40.Font.Charset := DEFAULT_CHARSET;
    WebLabel40.Font.Color := clWindowText;
    WebLabel40.Font.Height := -11;
    WebLabel40.Font.Name := 'Tahoma';
    WebLabel40.Font.Style := [];
    WebLabel40.ParentFont := False;
    WebLabel41.SetParentComponent(WebGroupBox2);
    WebLabel41.Name := 'WebLabel41';
    WebLabel41.Left := 668;
    WebLabel41.Top := 296;
    WebLabel41.Width := 18;
    WebLabel41.Height := 13;
    WebLabel41.Caption := 'PLN';
    WebLabel41.Font.Charset := DEFAULT_CHARSET;
    WebLabel41.Font.Color := clWindowText;
    WebLabel41.Font.Height := -11;
    WebLabel41.Font.Name := 'Tahoma';
    WebLabel41.Font.Style := [];
    WebLabel41.ParentFont := False;
    WebLabel42.SetParentComponent(WebGroupBox2);
    WebLabel42.Name := 'WebLabel42';
    WebLabel42.Left := 668;
    WebLabel42.Top := 319;
    WebLabel42.Width := 18;
    WebLabel42.Height := 13;
    WebLabel42.Caption := 'PLN';
    WebLabel42.Font.Charset := DEFAULT_CHARSET;
    WebLabel42.Font.Color := clWindowText;
    WebLabel42.Font.Height := -11;
    WebLabel42.Font.Name := 'Tahoma';
    WebLabel42.Font.Style := [];
    WebLabel42.ParentFont := False;
    WebLabel43.SetParentComponent(WebGroupBox2);
    WebLabel43.Name := 'WebLabel43';
    WebLabel43.Left := 668;
    WebLabel43.Top := 342;
    WebLabel43.Width := 18;
    WebLabel43.Height := 13;
    WebLabel43.Caption := 'PLN';
    WebLabel43.Font.Charset := DEFAULT_CHARSET;
    WebLabel43.Font.Color := clWindowText;
    WebLabel43.Font.Height := -11;
    WebLabel43.Font.Name := 'Tahoma';
    WebLabel43.Font.Style := [];
    WebLabel43.ParentFont := False;
    WebLabel44.SetParentComponent(WebGroupBox2);
    WebLabel44.Name := 'WebLabel44';
    WebLabel44.Left := 18;
    WebLabel44.Top := 98;
    WebLabel44.Width := 105;
    WebLabel44.Height := 13;
    WebLabel44.Caption := 'Cash Flow po 5 latach';
    WebLabel44.Font.Charset := DEFAULT_CHARSET;
    WebLabel44.Font.Color := clWindowText;
    WebLabel44.Font.Height := -11;
    WebLabel44.Font.Name := 'Tahoma';
    WebLabel44.Font.Style := [];
    WebLabel44.ParentFont := False;
    WebLabel49.SetParentComponent(WebGroupBox2);
    WebLabel49.Name := 'WebLabel49';
    WebLabel49.Left := 18;
    WebLabel49.Top := 148;
    WebLabel49.Width := 109;
    WebLabel49.Height := 13;
    WebLabel49.Caption := 'Warto'#347#263' resztkowa';
    WebLabel49.Font.Charset := DEFAULT_CHARSET;
    WebLabel49.Font.Color := clWindowText;
    WebLabel49.Font.Height := -11;
    WebLabel49.Font.Name := 'Tahoma';
    WebLabel49.Font.Style := [fsBold];
    WebLabel49.ParentFont := False;
    WebLabel62.SetParentComponent(WebGroupBox2);
    WebLabel62.Name := 'WebLabel62';
    WebLabel62.Left := 18;
    WebLabel62.Top := 173;
    WebLabel62.Width := 36;
    WebLabel62.Height := 13;
    WebLabel62.Caption := 'Odsetki';
    WebLabel62.Font.Charset := DEFAULT_CHARSET;
    WebLabel62.Font.Color := clWindowText;
    WebLabel62.Font.Height := -11;
    WebLabel62.Font.Name := 'Tahoma';
    WebLabel62.Font.Style := [];
    WebLabel62.ParentFont := False;
    WebLabel63.SetParentComponent(WebGroupBox2);
    WebLabel63.Name := 'WebLabel63';
    WebLabel63.Left := 18;
    WebLabel63.Top := 198;
    WebLabel63.Width := 143;
    WebLabel63.Height := 13;
    WebLabel63.Caption := 'Wynik przed opodatkowaniem';
    WebLabel63.Font.Charset := DEFAULT_CHARSET;
    WebLabel63.Font.Color := clWindowText;
    WebLabel63.Font.Height := -11;
    WebLabel63.Font.Name := 'Tahoma';
    WebLabel63.Font.Style := [];
    WebLabel63.ParentFont := False;
    WebLabel67.SetParentComponent(WebGroupBox2);
    WebLabel67.Name := 'WebLabel67';
    WebLabel67.Left := 18;
    WebLabel67.Top := 223;
    WebLabel67.Width := 196;
    WebLabel67.Height := 13;
    WebLabel67.Caption := 'Suma zweryfikownanego CashFlow';
    WebLabel67.Font.Charset := DEFAULT_CHARSET;
    WebLabel67.Font.Color := clWindowText;
    WebLabel67.Font.Height := -11;
    WebLabel67.Font.Name := 'Tahoma';
    WebLabel67.Font.Style := [fsBold];
    WebLabel67.ParentFont := False;
    WebLabel69.SetParentComponent(WebGroupBox2);
    WebLabel69.Name := 'WebLabel69';
    WebLabel69.Left := 17;
    WebLabel69.Top := 248;
    WebLabel69.Width := 50;
    WebLabel69.Height := 13;
    WebLabel69.Caption := 'Got'#243'wka';
    WebLabel69.Font.Charset := DEFAULT_CHARSET;
    WebLabel69.Font.Color := clWindowText;
    WebLabel69.Font.Height := -11;
    WebLabel69.Font.Name := 'Tahoma';
    WebLabel69.Font.Style := [fsBold];
    WebLabel69.ParentFont := False;
    WebLabel70.SetParentComponent(WebGroupBox2);
    WebLabel70.Name := 'WebLabel70';
    WebLabel70.Left := 17;
    WebLabel70.Top := 273;
    WebLabel70.Width := 80;
    WebLabel70.Height := 13;
    WebLabel70.Caption := 'Warto'#347#263' firmy';
    WebLabel70.Font.Charset := DEFAULT_CHARSET;
    WebLabel70.Font.Color := clWindowText;
    WebLabel70.Font.Height := -11;
    WebLabel70.Font.Name := 'Tahoma';
    WebLabel70.Font.Style := [fsBold];
    WebLabel70.ParentFont := False;
    WebLabel74.SetParentComponent(WebGroupBox2);
    WebLabel74.Name := 'WebLabel74';
    WebLabel74.Left := 18;
    WebLabel74.Top := 342;
    WebLabel74.Width := 80;
    WebLabel74.Height := 13;
    WebLabel74.Caption := 'Warto'#347#263' firmy';
    WebLabel74.Font.Charset := DEFAULT_CHARSET;
    WebLabel74.Font.Color := clBlue;
    WebLabel74.Font.Height := -11;
    WebLabel74.Font.Name := 'Tahoma';
    WebLabel74.Font.Style := [fsBold];
    WebLabel74.ParentFont := False;
    WebLabel76.SetParentComponent(WebGroupBox2);
    WebLabel76.Name := 'WebLabel76';
    WebLabel76.Left := 18;
    WebLabel76.Top := 319;
    WebLabel76.Width := 162;
    WebLabel76.Height := 13;
    WebLabel76.Caption := #346'rodki zb'#281'dne w dzia'#322'alno'#347'ci firmy';
    WebLabel76.Font.Charset := DEFAULT_CHARSET;
    WebLabel76.Font.Color := clWindowText;
    WebLabel76.Font.Height := -11;
    WebLabel76.Font.Name := 'Tahoma';
    WebLabel76.Font.Style := [];
    WebLabel76.ParentFont := False;
    WebLabel78.SetParentComponent(WebGroupBox2);
    WebLabel78.Name := 'WebLabel78';
    WebLabel78.Left := 17;
    WebLabel78.Top := 296;
    WebLabel78.Width := 60;
    WebLabel78.Height := 13;
    WebLabel78.Caption := 'Obcy kapita'#322;
    WebLabel78.Font.Charset := DEFAULT_CHARSET;
    WebLabel78.Font.Color := clWindowText;
    WebLabel78.Font.Height := -11;
    WebLabel78.Font.Name := 'Tahoma';
    WebLabel78.Font.Style := [];
    WebLabel78.ParentFont := False;
    WebLabel84.SetParentComponent(WebGroupBox2);
    WebLabel84.Name := 'WebLabel84';
    WebLabel84.Left := 18;
    WebLabel84.Top := 123;
    WebLabel84.Width := 126;
    WebLabel84.Height := 13;
    WebLabel84.Caption := 'Wspo'#322'czynnik gotowki';
    WebLabel84.Font.Charset := DEFAULT_CHARSET;
    WebLabel84.Font.Color := clWindowText;
    WebLabel84.Font.Height := -11;
    WebLabel84.Font.Name := 'Tahoma';
    WebLabel84.Font.Style := [fsBold];
    WebLabel84.ParentFont := False;
    WebLabel86.SetParentComponent(WebGroupBox2);
    WebLabel86.Name := 'WebLabel86';
    WebLabel86.Left := 18;
    WebLabel86.Top := 73;
    WebLabel86.Width := 181;
    WebLabel86.Height := 13;
    WebLabel86.Caption := 'Wspolcznniki obni'#380'enia warto'#347'ci';
    WebLabel86.Font.Charset := DEFAULT_CHARSET;
    WebLabel86.Font.Color := clWindowText;
    WebLabel86.Font.Height := -11;
    WebLabel86.Font.Name := 'Tahoma';
    WebLabel86.Font.Style := [fsBold];
    WebLabel86.ParentFont := False;
    WebLabel96.SetParentComponent(WebGroupBox2);
    WebLabel96.Name := 'WebLabel96';
    WebLabel96.Left := 95;
    WebLabel96.Top := 391;
    WebLabel96.Width := 99;
    WebLabel96.Height := 10;
    WebLabel96.Caption := '- prosz'#281' wype'#322'ni'#263' '#380#243#322'te pola';
    WebLabel96.Font.Charset := DEFAULT_CHARSET;
    WebLabel96.Font.Color := clWindowText;
    WebLabel96.Font.Height := -8;
    WebLabel96.Font.Name := 'Tahoma';
    WebLabel96.Font.Style := [];
    WebLabel96.ParentFont := False;
    WebEdit82.SetParentComponent(WebGroupBox2);
    WebEdit82.Name := 'WebEdit82';
    WebEdit82.Left := 321;
    WebEdit82.Top := 70;
    WebEdit82.Width := 61;
    WebEdit82.Height := 19;
    WebEdit82.ChildOrder := 1;
    WebEdit82.Color := 12903679;
    WebEdit82.Enabled := False;
    WebEdit82.Text := '1,00';
    WebEdit83.SetParentComponent(WebGroupBox2);
    WebEdit83.Name := 'WebEdit83';
    WebEdit83.Left := 321;
    WebEdit83.Top := 170;
    WebEdit83.Width := 61;
    WebEdit83.Height := 19;
    WebEdit83.ChildOrder := 5;
    WebEdit83.Color := 12903679;
    WebEdit83.Enabled := False;
    WebEdit83.Text := '632000';
    WebEdit84.SetParentComponent(WebGroupBox2);
    WebEdit84.Name := 'WebEdit84';
    WebEdit84.Left := 321;
    WebEdit84.Top := 195;
    WebEdit84.Width := 61;
    WebEdit84.Height := 19;
    WebEdit84.ChildOrder := 6;
    WebEdit84.Color := 12903679;
    WebEdit84.Text := '430000';
    WebEdit85.SetParentComponent(WebGroupBox2);
    WebEdit85.Name := 'WebEdit85';
    WebEdit85.Left := 321;
    WebEdit85.Top := 19;
    WebEdit85.Width := 61;
    WebEdit85.Height := 19;
    WebEdit85.ChildOrder := 8;
    WebEdit85.Color := 12903679;
    WebEdit85.Enabled := False;
    WebEdit85.Text := '2020';
    WebEdit86.SetParentComponent(WebGroupBox2);
    WebEdit86.Name := 'WebEdit86';
    WebEdit86.Left := 391;
    WebEdit86.Top := 19;
    WebEdit86.Width := 61;
    WebEdit86.Height := 19;
    WebEdit86.ChildOrder := 8;
    WebEdit86.Color := 12903679;
    WebEdit86.Enabled := False;
    WebEdit86.Text := '2021';
    WebEdit87.SetParentComponent(WebGroupBox2);
    WebEdit87.Name := 'WebEdit87';
    WebEdit87.Left := 391;
    WebEdit87.Top := 70;
    WebEdit87.Width := 61;
    WebEdit87.Height := 19;
    WebEdit87.ChildOrder := 1;
    WebEdit87.Color := 12903679;
    WebEdit87.Enabled := False;
    WebEdit87.Text := '0,9116';
    WebEdit88.SetParentComponent(WebGroupBox2);
    WebEdit88.Name := 'WebEdit88';
    WebEdit88.Left := 391;
    WebEdit88.Top := 170;
    WebEdit88.Width := 61;
    WebEdit88.Height := 19;
    WebEdit88.ChildOrder := 5;
    WebEdit88.Color := 12903679;
    WebEdit88.Enabled := False;
    WebEdit88.Text := '370000';
    WebEdit89.SetParentComponent(WebGroupBox2);
    WebEdit89.Name := 'WebEdit89';
    WebEdit89.Left := 391;
    WebEdit89.Top := 195;
    WebEdit89.Width := 61;
    WebEdit89.Height := 19;
    WebEdit89.ChildOrder := 6;
    WebEdit89.Color := 12903679;
    WebEdit89.Enabled := False;
    WebEdit89.Text := '327000';
    WebEdit90.SetParentComponent(WebGroupBox2);
    WebEdit90.Name := 'WebEdit90';
    WebEdit90.Left := 461;
    WebEdit90.Top := 19;
    WebEdit90.Width := 61;
    WebEdit90.Height := 19;
    WebEdit90.ChildOrder := 8;
    WebEdit90.Color := 12903679;
    WebEdit90.Enabled := False;
    WebEdit90.Text := '2022';
    WebEdit91.SetParentComponent(WebGroupBox2);
    WebEdit91.Name := 'WebEdit91';
    WebEdit91.Left := 461;
    WebEdit91.Top := 70;
    WebEdit91.Width := 61;
    WebEdit91.Height := 19;
    WebEdit91.ChildOrder := 1;
    WebEdit91.Color := 12903679;
    WebEdit91.Enabled := False;
    WebEdit91.Text := '0,8310';
    WebEdit92.SetParentComponent(WebGroupBox2);
    WebEdit92.Name := 'WebEdit92';
    WebEdit92.Left := 461;
    WebEdit92.Top := 170;
    WebEdit92.Width := 61;
    WebEdit92.Height := 19;
    WebEdit92.ChildOrder := 5;
    WebEdit92.Color := 12903679;
    WebEdit92.Enabled := False;
    WebEdit92.Text := '410000';
    WebEdit93.SetParentComponent(WebGroupBox2);
    WebEdit93.Name := 'WebEdit93';
    WebEdit93.Left := 461;
    WebEdit93.Top := 195;
    WebEdit93.Width := 61;
    WebEdit93.Height := 19;
    WebEdit93.ChildOrder := 6;
    WebEdit93.Color := 12903679;
    WebEdit93.Enabled := False;
    WebEdit93.Text := '341000';
    WebEdit94.SetParentComponent(WebGroupBox2);
    WebEdit94.Name := 'WebEdit94';
    WebEdit94.Left := 531;
    WebEdit94.Top := 19;
    WebEdit94.Width := 61;
    WebEdit94.Height := 19;
    WebEdit94.ChildOrder := 8;
    WebEdit94.Color := 12903679;
    WebEdit94.Enabled := False;
    WebEdit94.Text := '2023';
    WebEdit95.SetParentComponent(WebGroupBox2);
    WebEdit95.Name := 'WebEdit95';
    WebEdit95.Left := 531;
    WebEdit95.Top := 70;
    WebEdit95.Width := 61;
    WebEdit95.Height := 19;
    WebEdit95.ChildOrder := 1;
    WebEdit95.Color := 12903679;
    WebEdit95.Enabled := False;
    WebEdit95.Text := '0,7575';
    WebEdit96.SetParentComponent(WebGroupBox2);
    WebEdit96.Name := 'WebEdit96';
    WebEdit96.Left := 531;
    WebEdit96.Top := 170;
    WebEdit96.Width := 61;
    WebEdit96.Height := 19;
    WebEdit96.ChildOrder := 5;
    WebEdit96.Color := 12903679;
    WebEdit96.Enabled := False;
    WebEdit96.Text := '370000';
    WebEdit97.SetParentComponent(WebGroupBox2);
    WebEdit97.Name := 'WebEdit97';
    WebEdit97.Left := 531;
    WebEdit97.Top := 195;
    WebEdit97.Width := 61;
    WebEdit97.Height := 19;
    WebEdit97.ChildOrder := 6;
    WebEdit97.Color := 12903679;
    WebEdit97.Enabled := False;
    WebEdit97.Text := '280000';
    WebEdit98.SetParentComponent(WebGroupBox2);
    WebEdit98.Name := 'WebEdit98';
    WebEdit98.Left := 531;
    WebEdit98.Top := 220;
    WebEdit98.Width := 61;
    WebEdit98.Height := 19;
    WebEdit98.ChildOrder := 7;
    WebEdit98.Color := 12903679;
    WebEdit98.Enabled := False;
    WebEdit98.Text := '1388000';
    WebEdit99.SetParentComponent(WebGroupBox2);
    WebEdit99.Name := 'WebEdit99';
    WebEdit99.Left := 601;
    WebEdit99.Top := 245;
    WebEdit99.Width := 61;
    WebEdit99.Height := 19;
    WebEdit99.ChildOrder := 7;
    WebEdit99.Color := 12903679;
    WebEdit99.Enabled := False;
    WebEdit99.Text := '2634000';
    WebEdit100.SetParentComponent(WebGroupBox2);
    WebEdit100.Name := 'WebEdit100';
    WebEdit100.Left := 601;
    WebEdit100.Top := 19;
    WebEdit100.Width := 61;
    WebEdit100.Height := 19;
    WebEdit100.ChildOrder := 8;
    WebEdit100.Color := 12903679;
    WebEdit100.Enabled := False;
    WebEdit100.Text := '2024';
    WebEdit101.SetParentComponent(WebGroupBox2);
    WebEdit101.Name := 'WebEdit101';
    WebEdit101.Left := 601;
    WebEdit101.Top := 70;
    WebEdit101.Width := 61;
    WebEdit101.Height := 19;
    WebEdit101.ChildOrder := 1;
    WebEdit101.Color := 12903679;
    WebEdit101.Enabled := False;
    WebEdit101.Text := '0,6905';
    WebEdit102.SetParentComponent(WebGroupBox2);
    WebEdit102.Name := 'WebEdit102';
    WebEdit102.Left := 601;
    WebEdit102.Top := 95;
    WebEdit102.Width := 61;
    WebEdit102.Height := 19;
    WebEdit102.ChildOrder := 2;
    WebEdit102.Color := 12903679;
    WebEdit102.Enabled := False;
    WebEdit102.Text := '370000';
    WebEdit103.SetParentComponent(WebGroupBox2);
    WebEdit103.Name := 'WebEdit103';
    WebEdit103.Left := 601;
    WebEdit103.Top := 120;
    WebEdit103.Width := 61;
    WebEdit103.Height := 19;
    WebEdit103.ChildOrder := 3;
    WebEdit103.Color := 12903679;
    WebEdit103.Enabled := False;
    WebEdit103.Text := '10,3093';
    WebEdit104.SetParentComponent(WebGroupBox2);
    WebEdit104.Name := 'WebEdit104';
    WebEdit104.Left := 601;
    WebEdit104.Top := 145;
    WebEdit104.Width := 61;
    WebEdit104.Height := 19;
    WebEdit104.ChildOrder := 4;
    WebEdit104.Color := 12903679;
    WebEdit104.Enabled := False;
    WebEdit104.Text := '3814000';
    WebEdit105.SetParentComponent(WebGroupBox2);
    WebEdit105.Name := 'WebEdit105';
    WebEdit105.Left := 600;
    WebEdit105.Top := 270;
    WebEdit105.Width := 61;
    WebEdit105.Height := 19;
    WebEdit105.ChildOrder := 7;
    WebEdit105.Color := 12903679;
    WebEdit105.Enabled := False;
    WebEdit105.Text := '4022000';
    WebEdit106.SetParentComponent(WebGroupBox2);
    WebEdit106.Name := 'WebEdit106';
    WebEdit106.Left := 601;
    WebEdit106.Top := 294;
    WebEdit106.Width := 61;
    WebEdit106.Height := 19;
    WebEdit106.ChildOrder := 7;
    WebEdit106.Color := clInfoBk;
    WebEdit106.Text := '2022000';
    WebEdit107.SetParentComponent(WebGroupBox2);
    WebEdit107.Name := 'WebEdit107';
    WebEdit107.Left := 321;
    WebEdit107.Top := 43;
    WebEdit107.Width := 61;
    WebEdit107.Height := 19;
    WebEdit107.ChildOrder := 8;
    WebEdit107.Color := 12903679;
    WebEdit107.Enabled := False;
    WebEdit107.Text := '1';
    WebEdit108.SetParentComponent(WebGroupBox2);
    WebEdit108.Name := 'WebEdit108';
    WebEdit108.Left := 391;
    WebEdit108.Top := 43;
    WebEdit108.Width := 61;
    WebEdit108.Height := 19;
    WebEdit108.ChildOrder := 8;
    WebEdit108.Color := 12903679;
    WebEdit108.Enabled := False;
    WebEdit108.Text := '2';
    WebEdit109.SetParentComponent(WebGroupBox2);
    WebEdit109.Name := 'WebEdit109';
    WebEdit109.Left := 461;
    WebEdit109.Top := 43;
    WebEdit109.Width := 61;
    WebEdit109.Height := 19;
    WebEdit109.ChildOrder := 8;
    WebEdit109.Color := 12903679;
    WebEdit109.Enabled := False;
    WebEdit109.Text := '3';
    WebEdit110.SetParentComponent(WebGroupBox2);
    WebEdit110.Name := 'WebEdit110';
    WebEdit110.Left := 531;
    WebEdit110.Top := 43;
    WebEdit110.Width := 61;
    WebEdit110.Height := 19;
    WebEdit110.ChildOrder := 8;
    WebEdit110.Color := 12903679;
    WebEdit110.Enabled := False;
    WebEdit110.Text := '4';
    WebEdit111.SetParentComponent(WebGroupBox2);
    WebEdit111.Name := 'WebEdit111';
    WebEdit111.Left := 601;
    WebEdit111.Top := 43;
    WebEdit111.Width := 61;
    WebEdit111.Height := 19;
    WebEdit111.ChildOrder := 8;
    WebEdit111.Color := 12903679;
    WebEdit111.Enabled := False;
    WebEdit111.Text := '5';
    WebEdit112.SetParentComponent(WebGroupBox2);
    WebEdit112.Name := 'WebEdit112';
    WebEdit112.Left := 601;
    WebEdit112.Top := 316;
    WebEdit112.Width := 61;
    WebEdit112.Height := 19;
    WebEdit112.ChildOrder := 7;
    WebEdit112.Color := clInfoBk;
    WebEdit112.Text := '0';
    WebEdit113.SetParentComponent(WebGroupBox2);
    WebEdit113.Name := 'WebEdit113';
    WebEdit113.Left := 601;
    WebEdit113.Top := 339;
    WebEdit113.Width := 61;
    WebEdit113.Height := 19;
    WebEdit113.ChildOrder := 7;
    WebEdit113.Color := 12903679;
    WebEdit113.Enabled := False;
    WebEdit113.Text := '2000000';
    WebBitBtn4.SetParentComponent(WebGroupBox2);
    WebBitBtn4.Name := 'WebBitBtn4';
    WebBitBtn4.Left := 576;
    WebBitBtn4.Top := 367;
    WebBitBtn4.Width := 129;
    WebBitBtn4.Height := 37;
    WebBitBtn4.Caption := 'Przelicz';
    WebBitBtn4.Color := clBtnFace;
    WebBitBtn4.Glyph.LoadFromFile('Factor.WebGroupBox2.WebBitBtn4.Glyph.bmp');
    WebBitBtn4.TabOrder := 32;
    SetEvent(WebBitBtn4, Self, 'OnClick', 'WebBitBtn4Click');
    WebEdit117.SetParentComponent(WebGroupBox2);
    WebEdit117.Name := 'WebEdit117';
    WebEdit117.Left := 33;
    WebEdit117.Top := 387;
    WebEdit117.Width := 48;
    WebEdit117.Height := 19;
    WebEdit117.ChildOrder := 36;
    WebEdit117.Color := clInfoBk;
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel88.AfterLoadDFMValues;
    WebLabel90.AfterLoadDFMValues;
    WebLabel92.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WebGroupBox3.AfterLoadDFMValues;
    WebLabel45.AfterLoadDFMValues;
    WebLabel47.AfterLoadDFMValues;
    WebLabel48.AfterLoadDFMValues;
    WebLabel50.AfterLoadDFMValues;
    WebLabel51.AfterLoadDFMValues;
    WebLabel52.AfterLoadDFMValues;
    WebLabel53.AfterLoadDFMValues;
    WebLabel54.AfterLoadDFMValues;
    WebLabel55.AfterLoadDFMValues;
    WebLabel56.AfterLoadDFMValues;
    WebLabel57.AfterLoadDFMValues;
    WebLabel58.AfterLoadDFMValues;
    WebLabel59.AfterLoadDFMValues;
    WebLabel60.AfterLoadDFMValues;
    WebLabel61.AfterLoadDFMValues;
    WebLabel64.AfterLoadDFMValues;
    WebLabel65.AfterLoadDFMValues;
    WebLabel46.AfterLoadDFMValues;
    WebLabel72.AfterLoadDFMValues;
    WebLabel73.AfterLoadDFMValues;
    WebLabel81.AfterLoadDFMValues;
    WebLabel82.AfterLoadDFMValues;
    WebLabel83.AfterLoadDFMValues;
    WebLabel93.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit31.AfterLoadDFMValues;
    WebEdit32.AfterLoadDFMValues;
    WebEdit34.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebComboBox7.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit33.AfterLoadDFMValues;
    WebEdit35.AfterLoadDFMValues;
    WebBitBtn1.AfterLoadDFMValues;
    WebEdit114.AfterLoadDFMValues;
    WebPageControl1Sheet2.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel94.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
    WebEdit19.AfterLoadDFMValues;
    WebEdit20.AfterLoadDFMValues;
    WebEdit21.AfterLoadDFMValues;
    WebEdit22.AfterLoadDFMValues;
    WebEdit23.AfterLoadDFMValues;
    WebEdit24.AfterLoadDFMValues;
    WebEdit25.AfterLoadDFMValues;
    WebEdit26.AfterLoadDFMValues;
    WebEdit27.AfterLoadDFMValues;
    WebEdit28.AfterLoadDFMValues;
    WebEdit29.AfterLoadDFMValues;
    WebEdit30.AfterLoadDFMValues;
    WebEdit47.AfterLoadDFMValues;
    WebEdit48.AfterLoadDFMValues;
    WebEdit49.AfterLoadDFMValues;
    WebEdit50.AfterLoadDFMValues;
    WebEdit51.AfterLoadDFMValues;
    WebEdit52.AfterLoadDFMValues;
    WebEdit53.AfterLoadDFMValues;
    WebEdit54.AfterLoadDFMValues;
    WebEdit55.AfterLoadDFMValues;
    WebEdit56.AfterLoadDFMValues;
    WebEdit57.AfterLoadDFMValues;
    WebEdit58.AfterLoadDFMValues;
    WebEdit59.AfterLoadDFMValues;
    WebEdit60.AfterLoadDFMValues;
    WebEdit61.AfterLoadDFMValues;
    WebEdit62.AfterLoadDFMValues;
    WebEdit63.AfterLoadDFMValues;
    WebEdit64.AfterLoadDFMValues;
    WebEdit65.AfterLoadDFMValues;
    WebEdit66.AfterLoadDFMValues;
    WebEdit67.AfterLoadDFMValues;
    WebEdit68.AfterLoadDFMValues;
    WebEdit69.AfterLoadDFMValues;
    WebEdit70.AfterLoadDFMValues;
    WebEdit71.AfterLoadDFMValues;
    WebEdit72.AfterLoadDFMValues;
    WebEdit73.AfterLoadDFMValues;
    WebEdit74.AfterLoadDFMValues;
    WebEdit75.AfterLoadDFMValues;
    WebEdit76.AfterLoadDFMValues;
    WebEdit77.AfterLoadDFMValues;
    WebEdit78.AfterLoadDFMValues;
    WebEdit79.AfterLoadDFMValues;
    WebEdit80.AfterLoadDFMValues;
    WebEdit81.AfterLoadDFMValues;
    WebBitBtn2.AfterLoadDFMValues;
    WebEdit115.AfterLoadDFMValues;
    WebPageControl1Sheet3.AfterLoadDFMValues;
    WebGroupBox4.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebLabel71.AfterLoadDFMValues;
    WebLabel75.AfterLoadDFMValues;
    WebLabel77.AfterLoadDFMValues;
    WebLabel79.AfterLoadDFMValues;
    WebLabel80.AfterLoadDFMValues;
    WebLabel85.AfterLoadDFMValues;
    WebLabel87.AfterLoadDFMValues;
    WebLabel89.AfterLoadDFMValues;
    WebLabel91.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel95.AfterLoadDFMValues;
    WebImageControl4.AfterLoadDFMValues;
    WebEdit36.AfterLoadDFMValues;
    WebEdit37.AfterLoadDFMValues;
    WebEdit38.AfterLoadDFMValues;
    WebEdit39.AfterLoadDFMValues;
    WebEdit40.AfterLoadDFMValues;
    WebEdit41.AfterLoadDFMValues;
    WebEdit42.AfterLoadDFMValues;
    WebEdit43.AfterLoadDFMValues;
    WebEdit44.AfterLoadDFMValues;
    WebEdit45.AfterLoadDFMValues;
    WebEdit46.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebBitBtn3.AfterLoadDFMValues;
    WebEdit118.AfterLoadDFMValues;
    WebPageControl1Sheet4.AfterLoadDFMValues;
    WebGroupBox2.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebLabel40.AfterLoadDFMValues;
    WebLabel41.AfterLoadDFMValues;
    WebLabel42.AfterLoadDFMValues;
    WebLabel43.AfterLoadDFMValues;
    WebLabel44.AfterLoadDFMValues;
    WebLabel49.AfterLoadDFMValues;
    WebLabel62.AfterLoadDFMValues;
    WebLabel63.AfterLoadDFMValues;
    WebLabel67.AfterLoadDFMValues;
    WebLabel69.AfterLoadDFMValues;
    WebLabel70.AfterLoadDFMValues;
    WebLabel74.AfterLoadDFMValues;
    WebLabel76.AfterLoadDFMValues;
    WebLabel78.AfterLoadDFMValues;
    WebLabel84.AfterLoadDFMValues;
    WebLabel86.AfterLoadDFMValues;
    WebLabel96.AfterLoadDFMValues;
    WebEdit82.AfterLoadDFMValues;
    WebEdit83.AfterLoadDFMValues;
    WebEdit84.AfterLoadDFMValues;
    WebEdit85.AfterLoadDFMValues;
    WebEdit86.AfterLoadDFMValues;
    WebEdit87.AfterLoadDFMValues;
    WebEdit88.AfterLoadDFMValues;
    WebEdit89.AfterLoadDFMValues;
    WebEdit90.AfterLoadDFMValues;
    WebEdit91.AfterLoadDFMValues;
    WebEdit92.AfterLoadDFMValues;
    WebEdit93.AfterLoadDFMValues;
    WebEdit94.AfterLoadDFMValues;
    WebEdit95.AfterLoadDFMValues;
    WebEdit96.AfterLoadDFMValues;
    WebEdit97.AfterLoadDFMValues;
    WebEdit98.AfterLoadDFMValues;
    WebEdit99.AfterLoadDFMValues;
    WebEdit100.AfterLoadDFMValues;
    WebEdit101.AfterLoadDFMValues;
    WebEdit102.AfterLoadDFMValues;
    WebEdit103.AfterLoadDFMValues;
    WebEdit104.AfterLoadDFMValues;
    WebEdit105.AfterLoadDFMValues;
    WebEdit106.AfterLoadDFMValues;
    WebEdit107.AfterLoadDFMValues;
    WebEdit108.AfterLoadDFMValues;
    WebEdit109.AfterLoadDFMValues;
    WebEdit110.AfterLoadDFMValues;
    WebEdit111.AfterLoadDFMValues;
    WebEdit112.AfterLoadDFMValues;
    WebEdit113.AfterLoadDFMValues;
    WebBitBtn4.AfterLoadDFMValues;
    WebEdit117.AfterLoadDFMValues;
  end;
end;

end.
